import React from 'react'
import MaterialTable from 'material-table';
import Service from '../../config/networkutils';
import { withSnackbar } from 'notistack';
import RotateCircleLoading from 'react-loadingg/lib/RotateCircleLoading';
import { Accordion, AccordionDetails, AccordionSummary, Button, Chip, DialogContentText, IconButton, InputAdornment, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Toolbar, Tooltip, Typography } from '@material-ui/core';
import UploadIcon from '@material-ui/icons/CloudUpload'
import XLSX from "xlsx";
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { employees_and_projects, users_api, users_api_bulk_update, prp_template_api_bulk_update, getPromotion } from '../../config/apiList';
import Modal from '../../shared/Modal/Modal';
import ExcelDateToJSDate from '../../utils/excelDateToJSDate';
import Dropzone from '../../shared/Dropzone/Dropzone';
import { getCookie } from '../../utils/CookieHelper';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import AutcompleteInput from '../../shared/AutocompleteInput/Autocomplete';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Auth from '../../utils/authenticate';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import { changeItToMonday } from '../../utils/betweenDates';
import { removeAnElementFromTheArray, removeAnElementFromTheArrayAndAdd, applyQuantityToEveryWeek, customFilter } from '../../utils/reuseFunctions';
import { ExpandMore } from '@material-ui/icons';
import { Box, Paper, Tab, Tabs } from "@material-ui/core";
import PropTypes from 'prop-types';
import { Alert, Autocomplete } from '@material-ui/lab';
import Export from './Export';
import PromotionHistory from '../PromotionHistory/PromotionHistory';
import PromotionUnassignedSchedules from './PromotionunassignedSchedules';
import { CoffeeLoading } from 'react-loadingg';
import AddIcon from '@material-ui/icons/Add';
import GetAppIcon from '@material-ui/icons/GetApp';
import HistoryIcon from '@material-ui/icons/History';
import DateRangeIcon from '@material-ui/icons/DateRange';
import EditIcon from '@material-ui/icons/Edit';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import FilterListIcon from '@material-ui/icons/FilterList';
import { Checkbox, CircularProgress, ListItemText, Select } from '@mui/material';
import LinkIcon from '@material-ui/icons/Link';
import CloseIcon from '@material-ui/icons/Close';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import LineManagerTabs from '../LineManagers/LineManagerTabs';
import WorkOffIcon from '@material-ui/icons/WorkOff';
import LeaveRestrictionTabs from '../Leaves/LeaveRestrictions/LeaveRestrictionTabs';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import { getDataIsdeletedFalse, getPrimaryColor } from '../Helper/CommonThings';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import { CsvBuilder } from 'filefy';
import DeleteIcon from '@material-ui/icons/Delete';
import CommentIcon from '@mui/icons-material/Comment';
import CommentSection from './CommentSection/CommentSection';
import { BUArchiveReasonEnable, BUCommentEnable } from '../Helper/BUHelper/BUHelper';

const token = getCookie("ptd_ts_token");
const user = Auth.user();

const useStyles = (theme) => ({
});

const ScheduleMaker = ({ schedule }) => {
    return (
        <div style={{ paddingBottom: '1rem' }}><Typography>{`${schedule.from.slice(0, 10)} To ${schedule.to.slice(0, 10)}  Qty : ${schedule.qty}`}</Typography></div>
    )
}

const SchedulesContainer = ({ schedules }) => {
    return (
        < >
            {schedules.map((shdl, shdlIndex) => <ScheduleMaker key={shdlIndex} schedule={shdl} />)}
        </>
    )
}

const HistorySchedulesContainer = ({ crm_name, schedules }) => {
    return (
        < div style={{ margin: '1rem' }}>
            < h2 > {crm_name}</h2>
            {schedules.map((shdl, shdlIndex) => <ScheduleMaker key={shdlIndex} schedule={shdl} />)}
        </div>
    )
}

const type_of_experience = {
    role_history: "Role History",
    power_history: "Power History",
    bb_history: "BB History",
    descipline_history: 'Discipline History',
    client_history: 'Client History',
}

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Typography component={'span'} variant={'body2'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class Users extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            isLoading: true,
            tableLoading: true,
            owner_delivery_unit: {},
            c: {},
            sector: {},
            job_titles: {},
            reviewModal: false,
            dataToUpload: [],
            dropZoneModal: false,
            view_type: 'Live',
            market_subvertical: {},
            regionChangeDialog: false,
            selectedRegion: null,
            regionChangeDate: moment(),
            ownerRegionArray: [],
            selectedEmp: {},
            regionHistoryDialog: false,
            regionHistory: [],
            global_assign: false,
            promotionDialog: false,
            promoDescription: '',
            promotionDate: moment(),
            selectedRole: null,
            rolesArray: [],
            selectedPrps: [],
            verifyPromotionChanges: false,
            verifySchedules: [],
            promotionHistory: [],
            promotionHistorySchedules: false,
            tabValue: 0,
            postData: {
                emp_no: null,
                first_name: null,
                last_name: "",
                job_title: '',
                email: null,
                payrole_process_id: null,
                owner_region_id: null,
                owner_delivery_id: null,
                sector_id: null,
                market_subvertical: null,
                role_group_id: null,
                role_group_name: null,
                start_date: null,
                end_date: null
            },
            ownerDelivery: [],
            subSector: [],
            marketSubVertical: [],
            addDisabled: false,
            nextDisabled: true,
            type: 'add',
            job_titlesID: [],
            endDateDialog: false,
            endDateSubmitDisabled: false,
            confirmationButtonDisabled: false,
            promotionHistoryDialog: false,
            promotionGraphDialog: false,
            unassignedSchedules: [],
            promoteRoleLoading: false,
            live: [],
            archive: [],
            liveCopy: [],
            archiveCopy: [],
            filters: { 'job_roles': [], 'owner_region': [], 'sector': [], 'market_subvertical': [], 'self_parent': [], 'role_group_id': [], 'owner_delivery_unit': [], 'payrole_process': [] },
            page: 0,
            rowsPerPage: 10,
            jobRoles: [],
            sectorArray: [],
            orderBy: '',
            order: 'asc',
            subcontractorList: [],
            linkSubContractorDialog: false,
            selectedSubcontractor: null,
            linkDisabled: false,
            linkLineManagerDialog: false,
            linkEmployeeData: [],
            leaveRestrictionDialog: false,
            selectedUser: null,
            r12Data: [],
            r12Dialog: false,
            r12Loading: false,
            roleGroupLookup: {},
            lineManagerLookup: {},
            lineManagerArray: [],
            roleGroupArray: [],
            unarchiveEmployeeDialog: false,
            employeeHistoryDialog: false,
            yearsOfExperience: 0,
            typeOfExperience: null,
            employeeHistoryData: [],
            employeeHistoryLoading: false,
            liveRoleDropdown: [],
            selectedHistoryRole: null,
            selectedPastHistoryData: {},
            isEdit: false,
            businessUnitLookup: {},
            businessUnitDropdown: [],
            lookupData: {},
            filtersDisabled: false,
            selectedHistoryClient: null,
            selectedHistoryDescipline: null,
            columns: [
                { title: 'Id', field: 'id', editable: 'never' },
                { title: 'Employee No', field: 'emp_no' },
                { title: 'Availablity', field: 'availability' },
                {
                    title: 'First Name',
                    field: 'first_name',
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                },
                {
                    title: 'Job Title',
                    field: 'job_roles',
                },
                {
                    title: 'Role Group',
                    field: 'role_group_name',

                },
                { title: 'Payrole Process', field: 'payrole_process_name' },
                { title: 'Email Address', field: 'email' },
                { title: 'Line Manager', field: 'line_manager_name', },
                {
                    title: 'Sub Divison', field: 'owner_region_name', editable: 'onAdd',
                },
                { title: 'Operations Lead', field: 'owner_delivery_name', },
                {
                    title: 'Sector', field: 'sector_name',
                },
                {
                    title: 'Divison', field: 'market_subvertical_name',
                },
                {
                    title: 'BB History', field: 'bb_history'
                },
                {
                    title: 'Power History', field: 'power_history'
                },
                {
                    title: 'Start Date', field: 'start_date',
                    render: rowData => {
                        return rowData?.start_date ? moment(rowData?.start_date).format("DD/MM/YYYY") : ''
                    }
                },
                {
                    title: 'End Date', field: 'end_date',
                    render: rowData => {
                        return rowData?.end_date ? moment(rowData?.end_date).format("DD/MM/YYYY") : ''
                    }
                },
                {
                    title: 'Date Created', field: 'date_created',
                    render: rowData => {
                        return rowData?.date_created ? moment(rowData?.date_created).format("DD/MM/YYYY") : ''
                    }
                },
            ],
            payroleLookup: {},
            payroleArray: [],
            excelExportDisabled: false,
            exportFilterDialogOpen: false,
            exportFilterSelection: {
                job_roles: true,
                owner_region: true,
                sector: true,
                market_subvertical: true,
                self_parent: true,
                role_group_id: true,
                owner_delivery_unit: true,
                payrole_process: true
            },
            isAtr: false,
            crmData: [],
            deleteEmployeeDialog: false,
            selectedDeleteEmployee: null,
            clientData: [],
            commentDialog: false,
            archiveReasons: [],
            selectedArchiveReason: null,
            archiveReasonLoading: false
        }
        this.closeDialog = this.closeDialog.bind(this)
        this.closePromotionDialog = this.closePromotionDialog.bind(this)
        this.reloadEmployeeData = this.reloadEmployeeData.bind(this)
        this.updateComment = this.updateComment.bind(this)
    }

    getSubContractor() {
        Service.get('/api/subcontractor/get_subcontractor/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                this.setState({ subcontractorList: resData })
            })
            .catch(error => {
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
    }

    getRoleGroup() {
        return new Promise((resolve, reject) => {
            Service.get('/api/role/group/get_business_unit_role_groups/', {
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    let resData = getDataIsdeletedFalse(res.data);
                    resolve(resData)
                })
                .catch(error => reject(error))
        })
    }

    getBusinessUnit() {
        return new Promise((resolve, reject) => {
            Service.get('/api/business/unit', {
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    let resData = getDataIsdeletedFalse(res.data);
                    resolve(resData)
                })
                .catch(error => reject(error))
        })
    }

    getLookup() {
        this.setState({ filtersDisabled: true })
        Service.get('/api/past/employee/history/lookup_data/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    lookupData: res.data,
                    filtersDisabled: false
                })

            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    getPayrole() {
        return new Promise((resolve, reject) => {
            Service.get('/api/pay/role/process/get_pay_role_data/', {
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    let resData = getDataIsdeletedFalse(res.data);
                    resolve(resData)
                })
                .catch(error => reject(error))
        })
    }

    componentDidMount() {
        if (this.props.subcontractor) {
            this.setState({ selectedSubcontractor: this.props.subcontractor })
        }

        var columns = [...this.state.columns]
        var existingColumn = columns.find((col) => col.field === 'external_name')

        if (this.props.byEmployees) {
            let filters = { ...this.state.filters }
            filters['external'] = []
            if (!existingColumn) {
                columns.splice(6, 0, { title: 'External', field: 'external_name' })
                this.setState({ columns, filters: filters })
            }
        } else {
            if (existingColumn) {
                columns = columns.filter((col) => col.field !== 'external_name')
                this.setState({ columns })
            }
        }
        this.getClientData()
        this.fetchOps()
        this.getLookup()
        this.getCrm()
    }

    getClientData() {
        Service.get('/api/ptd/account/get_with_delete_status/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    clientData: res.data,
                })

            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    getCrm() {
        Service.get('/api/crm/get_crm_data/?is_trashed=False', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    crmData: res.data,
                    filtersDisabled: false
                })

            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    getPromotionHistory(employee) {
        Service.get(`${getPromotion}?ptd_employee=${employee.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => { this.setState({ promotionHistory: res.data }) })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
            })
    }

    fetchEmployeeProjects(empId) {
        this.setState({ promoteRoleLoading: true })
        Service.get(employees_and_projects + `?is_archive=0&emp_id=${empId}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                this.setState({ PromtingEmpdata: resData })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
            .finally(() => {
                this.setState({ promoteRoleLoading: false, promotionDialog: true, })
            });
    }

    fetchOps() {
        var url = ''
        if (this.props.subcontractor) {
            url = `/api/ptd/employees/employee_data/?employee_type=external&subcontractor_id=${this.props.subcontractor.id}`
        } else if (this.props.byEmployees) {
            url = `/api/prp/template/external_employee_list/`
        } else {
            url = '/api/ptd/employees/employee_data/?employee_type=internal'
        }
        this.setState({ tableLoading: true })
        Service.get(url, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                let archive = []; let live = [];
                let lineManagerArray = [];
                let lineManagerLookup = {};
                resData.forEach(emp => {
                    if (emp.self_parent) {
                        lineManagerArray = [...lineManagerArray, { id: emp.self_parent, name: emp.line_manager_first_name + ' ' + emp.line_manager_last_name }]
                        lineManagerLookup = { ...lineManagerLookup, ...{ [emp.self_parent]: emp.line_manager_first_name + ' ' + emp.line_manager_last_name } }
                    }
                    if (moment(emp.end_date).isBefore(moment().format())) {
                        archive.push(emp)
                    }
                    else live.push(emp)
                })
                this.setState({ lineManagerArray, lineManagerLookup, live, archive, tableLoading: false, isLoading: false, liveCopy: live, archiveCopy: archive, linkEmployeeData: live }, () => {
                    if (Object.keys(this.state.filters).length > 0) {
                        this.handleFilterData(this.state.tabValue === 0 ? 'live' : 'archive')
                    }
                })
            })
            .catch(error => {
                console.log(error)
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
            .finally(() => {
                setTimeout(() => {
                    this.setState({ tableLoading: false, isLoading: false })
                }, 1000);
            });
    }

    postOps(postData) {
        let fields = ""
        if (!postData.emp_no) {
            fields += "Employee Number"
        }
        if (!postData.first_name) {
            fields += !fields ? "First Name" : ", First Name"
        }
        if (!postData.last_name) {
            fields += !fields ? "Last Name" : ", Last Name"
        }
        if (!postData.job_title) {
            fields += !fields ? "Job Title" : ", Job Title"
        }
        // if (!postData.email) {
        //     fields += !fields ? "Email" : ", Email"
        // }
        if (!postData.owner_region_id) {
            fields += !fields ? "Sub Division" : ", Sub Division"
        }
        if (!postData.owner_delivery_id) {
            fields += !fields ? "Operations Lead" : ", Operations Lead"
        }
        if (!postData.sector_id) {
            fields += !fields ? "Sector" : ", Sector"
        }
        if (!postData.start_date) {
            fields += !fields ? "Start Date" : ", Start Date"
        }
        if (!postData.payrole_process_id) {
            fields += !fields ? "Payrole Process" : ", Payrole Process"
        }

        if (!fields) {
            this.setState({ addDisabled: true })
            var data = { ...postData }
            data.global_assign = this.state.global_assign ? 1 : 0
            data.availability = 1
            data.owner_region = postData.owner_region_id
            data.owner_delivery_unit = postData.owner_delivery_id
            data.sector = postData.sector_id
            data.market_subvertical = postData.market_subvertical
            data.payrole_process = postData.payrole_process_id
            data.role_group = postData.role_group_id
            data.bb_history = postData.bb_history
            data.power_history = postData.power_history
            if (this.props.subcontractor) {
                data.subcontractor = this.props.subcontractor.id
            }
            Service.post('/api/ptd/employees/create_employee/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data,
            })
                .then(res => {

                    this.setState({
                        postData: {
                            emp_no: null,
                            first_name: '',
                            last_name: "",
                            job_title: '',
                            email: null,
                            owner_region: null,
                            owner_delivery_unit: null,
                            sector: null,
                            market_subvertical: null,
                            role_group_id: null,
                            role_group_name: null,
                            start_date: null,
                            end_date: null,
                            business_unit: null
                        },
                        addDisabled: false,
                        addUser: false,
                        r12Dialog: false,
                        isAtr: false
                    })
                    this.fetchOps();
                    this.props.enqueueSnackbar('Client added successfully', {
                        variant: 'success'
                    });
                })
                .catch(error => {
                    this.setState({ tableLoading: false, addDisabled: false })
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                })
        } else {
            this.props.enqueueSnackbar(fields + " is Empty!", {
                variant: 'warning'
            });
        }
        // .finally(() => { this.setState({ isLoading: false }) });;
    }

    putOps(postData) {
        let fields = ""
        if (!postData.emp_no) {
            fields += "Employee Number"
        }
        if (!postData.first_name) {
            fields += !fields ? "First Name" : ", First Name"
        }
        if (!postData.last_name) {
            fields += !fields ? "Last Name" : ", Last Name"
        }
        if (!postData.job_title) {
            fields += !fields ? "Job Title" : ", Job Title"
        }
        // if (!postData.email) {
        //     fields += !fields ? "Email" : ", Email"
        // }
        if (!postData.owner_region_id) {
            fields += !fields ? "Sub Division" : ", Sub Division"
        }
        if (!postData.owner_delivery_id) {
            fields += !fields ? "Operations Lead" : ", Operations Lead"
        }
        if (!postData.sector_id) {
            fields += !fields ? "Sector" : ", Sector"
        }
        if (!postData.start_date) {
            fields += !fields ? "Start Date" : ", Start Date"
        }
        if (!postData.availability) {
            fields += !fields ? "Availability" : ", Availability"
        }
        if (!postData.payrole_process_id) {
            fields += !fields ? "Payrole Process" : ", Payrole Process"
        }

        if (!fields) {
            this.setState({ addDisabled: true })
            let data = { ...postData }
            data.owner_region = postData.owner_region_id
            data.owner_delivery_unit = postData.owner_delivery_id
            data.sector = postData.sector_id
            data.market_subvertical = postData.market_subvertical
            data.payrole_process = postData.payrole_process_id
            data.role_group = postData.role_group_id
            Service.patch('/api/ptd/employees/update_employee/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data,
            })
                .then(res => {
                    this.fetchOps()
                    this.setState({
                        postData: {
                            emp_no: null,
                            first_name: null,
                            last_name: null,
                            job_title: null,
                            email: null,
                            owner_region: null,
                            owner_delivery_unit: null,
                            sector: null,
                            market_subvertical: null,
                            role_group_id: null,
                            role_group_name: null,
                            start_date: null,
                            end_date: null,
                            availability: null
                        },
                        addDisabled: false,
                        addUser: false
                    })
                    this.props.enqueueSnackbar('Successfully Updated', {
                        variant: 'success'
                    });
                })
                .catch(error => {
                    this.setState({ tableLoading: false, addDisabled: false })
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                    this.fetchOps();
                });
        } else {
            this.props.enqueueSnackbar(fields + " is Empty!", {
                variant: 'warning'
            });
        }
    }

    deleteOps(data) {
        Service.delete(users_api + data.id + "/", {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                this.fetchOps()
                this.props.enqueueSnackbar('Deleted successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                this.setState({ tableLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.fetchOps();
            });
    }

    deleteEmployee = (data) => {
        this.setState({
            deleteEmployeeDialog: true,
            selectedDeleteEmployee: data
        })
    }

    deleteEmployeeDialogClose = () => {
        this.setState({
            deleteEmployeeDialog: false,
            selectedDeleteEmployee: null
        })
    }

    deleteEmployeeDialogOk = () => {
        // Add delete employee API call here using this.state.selectedDeleteEmployee.
        // /api/ptd/employees/delete_employee/
        Service.patch('/api/ptd/employees/delete_employee/?employee_id=' + this.state.selectedDeleteEmployee.id, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.props.enqueueSnackbar('Employee Deleted Successfully', {
                    variant: 'success'
                })
                this.setState({
                    deleteEmployeeDialog: false,
                    selectedDeleteEmployee: null
                })
                this.fetchOps()
            })
            .catch(error => {
                this.setState({ deleteEmployeeDialog: false, selectedDeleteEmployee: null })
                if (error.status === 400) {
                    this.props.enqueueSnackbar('Bad Request', {
                        variant: 'error'
                    });
                } else if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
    }

    usersBulkPost(data) {
        Service.post('/api/ptd/employees/create_employee/', {
            headers: {
                Authorization: "Token " + token,
            },
            data
        })
            .then(res => {
                this.props.enqueueSnackbar(res.data.length + (res.data.length === 1 ? 'Employee' : ' Employees') + ' added successfully', {
                    variant: 'success'
                })
                this.setState({
                    reviewModal: false,
                    dataToUpload: [],
                    dropZoneModal: false,
                    bulkUploadLoader: false
                })
                this.fetchOps()
            })
            .catch(error => {
                this.setState({ bulkUploadLoader: false })
                if (error.status === 400) {
                    if (error.data.length) {
                        for (let i = 0; i < error.data.length; i++) {
                            const err = error.data[i]
                            let hasError = Object.keys(err).length !== 0 && err.constructor === Object;
                            if (hasError) {
                                for (const e in err) {
                                    this.props.enqueueSnackbar("Upload error : " + (data[i]['emp_no'] ? data[i]['emp_no'] : '') + " - " + e + " (" + err[e] + ")", {
                                        variant: 'error'
                                    });
                                    return;
                                }
                            }
                        }
                    }
                }
                else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
    }

    usersBulkUpdate(data) {
        Service.patch(users_api_bulk_update, {
            headers: {
                Authorization: "Token " + token,
            },
            data
        })
            .then(res => {
                this.props.enqueueSnackbar(res.data.length + (res.data.length === 1 ? ' Employee' : ' Employees') + ' updated successfully', {
                    variant: 'success'
                });
                this.setState({
                    reviewModal: false,
                    dataToUpload: [],
                    dropZoneModal: false,
                })
                this.fetchOps()
            })
            .catch(e => {
                console.error(e)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
            .finally(() => {
                this.setState({ bulkUploadLoader: false })
            })
    }

    reviewModalOpen = () => { this.setState({ reviewModal: true }) }

    reviewModalClose = () => { this.setState({ reviewModal: false }) }

    fileToRead(files) {
        if (!files || !files[0]) return;
        let f = files[0];
        try {
            const reader = new FileReader();
            const rABS = !!reader.readAsBinaryString;

            reader.onload = (e) => {
                /* read workbook */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });

                /* grab first sheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];

                /* save data */
                const data = XLSX.utils.sheet_to_json(ws)

                data.forEach(ele => {
                    if (ele.start_date) ele.start_date = ExcelDateToJSDate(ele.start_date);
                    if (ele.end_date) ele.end_date = ExcelDateToJSDate(ele.end_date);
                    if (ele.job_title) {
                        for (let k in this.state.job_titlesID) {
                            if (String(this.state.job_titlesID[k]).trim() === String(ele.job_title).trim()) {
                                ele.job_title = k
                            }
                        }
                    }
                    if (ele.owner_region) {
                        for (let k in this.state.owner_region) {
                            if (String(this.state.owner_region[k]).trim() === String(ele.owner_region).trim()) {
                                ele.owner_region = k
                            }
                        }
                    }
                    if (ele.owner_delivery_unit) {
                        for (let k in this.state.owner_delivery_unit) {
                            if (String(this.state.owner_delivery_unit[k]).trim() === String(ele.owner_delivery_unit).trim()) {
                                ele.owner_delivery_unit = k
                            }
                        }
                    }
                    if (ele.sector) {
                        for (let k in this.state.sector) {
                            if (String(this.state.sector[k]).trim() === String(ele.sector).trim()) {
                                ele.sector = k
                            }
                        }
                    }
                    if (ele.market_subvertical) {
                        for (let k in this.state.market_subvertical) {
                            if (String(this.state.market_subvertical[k]).trim() === String(ele.market_subvertical).trim()) {
                                ele.market_subvertical = k
                            }
                        }
                    }
                    if (this.props.subcontractor) {
                        ele.subcontractor = this.props.subcontractor.id
                    }
                })
                this.setState({ dataToUpload: data })
            };
            if (rABS) {
                reader.readAsBinaryString(f);
            } else {
                reader.readAsArrayBuffer(f);
            }
        }
        catch (e) {
            console.error(e)
        }
    }

    bulkUpload = () => {
        this.setState({ bulkUploadLoader: true })
        let dataToUpload = [...this.state.dataToUpload]
        let dataToUpdate = []
        dataToUpload.forEach((ele, i) => {
            this.state.data.forEach(emp => {
                if (String(ele.emp_no) === String(emp.emp_no)) {
                    ele.id = emp.id;
                    dataToUpdate.push(ele)
                }
            })
        })
        dataToUpdate.forEach((ele) => {
            dataToUpload.forEach((ele2, i) => {
                if (String(ele.emp_no) === String(ele2.emp_no)) {
                    dataToUpload.splice(i, 1)
                }
            })
        })

        if (dataToUpload.length) {
            let arr = [];
            for (let i = 1; i <= dataToUpload.length; i++) {
                arr.push(dataToUpload[i - 1])
                if (i === 1000 * Number((i / 1000).toFixed())) {
                    this.usersBulkPost(arr)
                    arr = []
                }
                if (i === dataToUpload.length) {
                    this.usersBulkPost(arr)
                }
            }
        }
        if (dataToUpdate.length) {
            let arr = [];
            for (let i = 1; i <= dataToUpdate.length; i++) {
                arr.push(dataToUpdate[i - 1])
                if (i === 1000 * Number((i / 1000).toFixed())) {
                    this.usersBulkUpdate(arr)
                    arr = []
                }
                if (i === dataToUpdate.length && arr.length) {
                    this.usersBulkUpdate(arr)
                }
            }
        }
    }

    dropzoneClose = () => {
        this.setState({ dropZoneModal: false })
    }

    handleViewType(e, newValue) {
        this.setState({ tabValue: newValue }, () => {
            this.handleFilterData(this.state.tabValue === 0 ? 'live' : 'archive')
        })
    }

    promotionDialogClose = () => {
        this.setState({ promotionDialog: false, selectedRole: '', selectedEmp: '', promotionDate: moment(), promotionDescription: '' })
    }

    promotionHistoryDialogClose = () => {
        this.setState({ promotionHistoryDialog: false, })
    }

    regionChangeDialogClose = () => {
        this.setState({ regionChangeDialog: false })
    }

    getRegionChangeInfo(data) {
        Service.get('/api/ptd/history/employees/?ptd_employee=' + data.id, {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                this.setState({ regionHistoryDialog: true, regionHistory: res.data })
            })
            .catch(error => {
                this.setState({ tableLoading: false, })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    regionHistoryDialogClose = () => {
        this.setState({ regionHistoryDialog: false })
    }

    promotionOps(data) {
        this.fetchEmployeeProjects(data.id)
    }

    regionChangeOps(data) {
        Service.get('/api/ptd/history/employees/?ptd_employee=' + data.id, {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                this.setState({
                    selectedEmp: data,
                    regionHistory: res.data,
                    selectedRegion: this.state.ownerRegionArray.find(ele => ele.id === data.owner_region),
                    regionChangeDialog: true,
                })
            })
            .catch(error => {
                this.setState({ tableLoading: false, })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    alterSchedules() {
        let promotionDate = this.state.promotionDate
        let scheduleChangeProjects = JSON.parse(JSON.stringify(this.state.selectedPrps))
        let oldScheduleChangeProjects = JSON.parse(JSON.stringify(this.state.selectedPrps))
        let newScheduleChangeProjects = JSON.parse(JSON.stringify(this.state.selectedPrps))
        let verifySchedules = []

        for (let projectIndex = 0; projectIndex < scheduleChangeProjects.length; projectIndex++) {
            let oldCRMSchedules = []
            let newCRMSchedules = []
            let curentCRMSchedules = []
            for (let shdlIndex = 0; shdlIndex < scheduleChangeProjects[projectIndex].shdl_data?.length; shdlIndex++) {
                curentCRMSchedules.push(scheduleChangeProjects[projectIndex].shdl_data[shdlIndex])
                //    Find If promotion date is before from date
                if (scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].from &&
                    scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].to
                    && promotionDate) {
                    if (moment(scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].from.slice(0, 10)).isSameOrAfter(
                        moment(promotionDate, "MM/dd/yyyy").toISOString().slice(0, 10))) {
                        oldScheduleChangeProjects[projectIndex]['shdl_data'] = removeAnElementFromTheArray(oldScheduleChangeProjects[projectIndex]['shdl_data'], scheduleChangeProjects[projectIndex].shdl_data[shdlIndex])
                        newCRMSchedules.push(scheduleChangeProjects[projectIndex].shdl_data[shdlIndex])
                    }
                    //    Find If promotion date is before to date
                    else if (moment(scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].to.slice(0, 10)).isSameOrBefore(
                        moment(promotionDate, "MM/dd/yyyy").toISOString().slice(0, 10))) {
                        newScheduleChangeProjects[projectIndex]['shdl_data'] = removeAnElementFromTheArray(newScheduleChangeProjects[projectIndex]['shdl_data'], scheduleChangeProjects[projectIndex].shdl_data[shdlIndex])
                        oldCRMSchedules.push(scheduleChangeProjects[projectIndex].shdl_data[shdlIndex])
                    }
                    //    Find If promotion date is between from and to date
                    else if (moment(promotionDate, "MM/dd/yyyy").isBetween(scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].from.slice(0, 10), scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].to.slice(0, 10))
                    ) {
                        oldScheduleChangeProjects[projectIndex]['shdl_data'] = removeAnElementFromTheArrayAndAdd(oldScheduleChangeProjects[projectIndex]['shdl_data'], scheduleChangeProjects[projectIndex].shdl_data[shdlIndex], {
                            from: scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].from,
                            to: changeItToMonday(moment(promotionDate, "MM/dd/yyyy").subtract(7, 'days')),
                            qty: scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].qty
                        })
                        oldCRMSchedules.push({
                            from: scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].from,
                            to: changeItToMonday(moment(promotionDate, "MM/dd/yyyy").subtract(7, 'days')),
                            qty: scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].qty
                        })

                        newScheduleChangeProjects[projectIndex]['shdl_data'] = removeAnElementFromTheArrayAndAdd(newScheduleChangeProjects[projectIndex]['shdl_data'], scheduleChangeProjects[projectIndex].shdl_data[shdlIndex], {
                            from: moment(promotionDate, "MM/dd/yyyy").toISOString(),
                            to: scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].to,
                            qty: scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].qty
                        })
                        newCRMSchedules.push({
                            from: moment(promotionDate, "MM/dd/yyyy").toISOString(),
                            to: scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].to,
                            qty: scheduleChangeProjects[projectIndex].shdl_data[shdlIndex].qty
                        })
                    }
                }

            }

            verifySchedules.push({ crm: scheduleChangeProjects[projectIndex].crm_name, oldCRMSchedules, newCRMSchedules, curentCRMSchedules })
        }
        // oldScheduleChangeProjects = applyQuantityToEveryWeek(oldScheduleChangeProjects)
        newScheduleChangeProjects = applyQuantityToEveryWeek(newScheduleChangeProjects)
        this.setState({ verifySchedules, oldScheduleChangeProjects, newScheduleChangeProjects, verifyPromotionChanges: true })
    }

    createOldSchedules(data) {
        return new Promise((resolve, reject) => {
            Service.post('/api/ptd/employee/promotion/employee_role_upgrade2/', { headers: { Authorization: "Token " + token }, data }).then(res => resolve(res.data)).catch(error => { reject(error); console.log(error) })
        })
    }

    updateNewSchedules(data) {
        return new Promise((resolve, reject) => {
            Service.patch(prp_template_api_bulk_update, {
                headers: {
                    Authorization: "Token " + token,
                },
                data,
            }).then(res => resolve(res.data)).catch((error => reject(error)))
        })
    }

    submitPromotion(state) {
        let promoData = {
            emp: state.selectedEmp.id,
            role: state.selectedRole.id,
            migration_taken: { previousRole: { role: state.selectedEmp.job_title, schdl_data: state.oldScheduleChangeProjects }, promotionDate: state.promotionDate, Description: state.promoDescription }
        }
        Promise.all([this.createOldSchedules(promoData)]).then(res => {
            this.fetchOps();
            this.promotionDialogClose()
            this.setState({ verifyPromotionChanges: false, promoDescription: '' })
            this.props.enqueueSnackbar("promoting Employee Success!", {
                variant: "success",
            });
        }).catch((error) => {
            console.log(error)
            this.props.enqueueSnackbar("Promoting employee failed!", {
                variant: "error",
            });
        });
    }

    submitRegionChange() {
        let oldRegion;
        for (let i = 0; i < this.state.regionHistory.length; i++) {
            if (moment(this.state.regionHistory[i].changed_on).isBefore(this.state.regionChangeDate)) {
                oldRegion = this.state.regionHistory[i].new_owner_region
            }
        }
        if (oldRegion === this.state.selectedRegion.id) {
            this.props.enqueueSnackbar('Selected region can not be same as previous region ', {
                variant: 'warning'
            });
            return;
        }
        let newData = { ...this.state.selectedEmp, ...{ owner_region: this.state.selectedRegion.id } }

        Service.post('/api/ptd/history/employees/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                changed_on: this.state.regionChangeDate,
                new_owner_region: this.state.selectedRegion.id,
                current_owner_region: this.state.selectedEmp.owner_region,
                ptd_employee: this.state.selectedEmp.id,
                created_by: user.id
            },
        })
            .then(res => {
                if (moment(this.state.regionChangeDate).isSameOrBefore()) {
                    this.putOps(newData)
                }
                this.regionChangeDialogClose()
                this.props.enqueueSnackbar('Region updated successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                this.setState({ tableLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    handleTextChange(e) {
        let postData = this.state.postData
        postData[e.target.id] = e.target.value
        this.setState({ postData })
    }

    handleSelectChange = (id, name, values) => {
        var postData = this.state.postData
        if (values) {
            postData[id] = values.id
            postData[name] = values.name
        } else {
            postData[id] = null
            postData[name] = null
        }
        this.setState({ postData });
    }

    fieldHasValue = (value) => value !== null && value !== undefined && String(value) !== ''

    getInputLabelProps = (value, labelProps = {}) => this.fieldHasValue(value) ? { ...labelProps, shrink: true } : labelProps

    getNormalizedEditPostData = (row) => {
        const postData = JSON.parse(JSON.stringify(row || {}))

        // Edit validation uses payrole_process_id; some rows only carry payrole_process.
        postData.payrole_process_id = postData.payrole_process_id || postData.payrole_process || null
        if (!postData.payrole_process_name && postData.payrole_process_id) {
            const payrole = (this.state.lookupData?.payrole_process || []).find(
                (item) => String(item.id) === String(postData.payrole_process_id)
            )
            if (payrole) {
                postData.payrole_process_name = payrole.name
            }
        }

        if (Array.isArray(postData.role_group_id)) {
            postData.role_group_id = postData.role_group_id[0] || null
        }
        if (!postData.role_group_name && Array.isArray(postData.role_group_names)) {
            postData.role_group_name = postData.role_group_names[0] || null
        }

        return postData
    }

    assignEndDate(postData) {
        this.setState({
            confirmationButtonDisabled: true
        })

        var inputData = {
            emp_id: postData.id,
            leave_date: postData.end_date
        }

        if (BUArchiveReasonEnable(postData.bu_key) && this.state.selectedArchiveReason) {
            inputData.archive_reason_id = this.state.selectedArchiveReason.id
        }
        Service.patch(`/api/role/schedule/leavers_allocation_removal/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: inputData,
        })
            .then(res => {
                this.setState({
                    tableLoading: true,
                    endDateDialog: false,
                    confirmationButtonDisabled: false,
                    confirmationDialog: false,
                    selectedArchiveReason: null
                })
                this.fetchOps()
                this.props.enqueueSnackbar('End Date Assigned Successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                this.setState({ endDateDialog: false })
                console.log(error)
                if (error.status === 406) {
                    this.props.enqueueSnackbar('Assigned End Date and Employee End Date is Same', {
                        variant: 'error'
                    });
                } else if (error.status === 400) {
                    this.props.enqueueSnackbar(error.data.msg, {
                        variant: 'error'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
    }

    getUnassignedSchedules() {
        Service.get(`/api/ptd/employee/promotion/get_unassinged_schlds_for_future_roles/?emp_id=${this.state.selectedEmp.id}&promoted_role_id=${this.state.selectedRole.id}&promotion_date=${moment(this.state.promotionDate).format("YYYY-MM-DD")}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    unassignedSchedules: res.data
                }, () => {
                    this.setState({ promotionGraphDialog: true })
                })
            })
            .catch(error => {
                this.setState({ tableLoading: false })
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    closeDialog() {
        this.setState({ promotionHistoryDialog: false })
    }

    closePromotionDialog(value) {
        this.setState({ promotionGraphDialog: false, })
        if (value) {
            this.setState({ promotionDialog: false, tableLoading: true })
            this.fetchOps()
        }
    }

    handleFilterChange = (e, type) => {
        const key = e.target.name || e.target.id
        const value = e.target.value
        const multiSelectKeys = ['job_roles', 'owner_region', 'owner_delivery_name', 'owner_delivery_unit', 'sector', 'market_subvertical', 'self_parent', 'role_group_id',]
        if (this.props.byEmployees) {
            multiSelectKeys.push('external')
        }

        const normalizedValue = multiSelectKeys.includes(key)
            ? (Array.isArray(value) ? value : (typeof value === 'string' ? value.split(',').filter(Boolean) : []))
            : value

        this.setState((prevState) => {
            const filters = { ...prevState.filters }

            if (Array.isArray(normalizedValue)) {
                filters[key] = normalizedValue
            } else {
                filters[key] = normalizedValue === null || typeof normalizedValue === 'undefined' ? '' : normalizedValue
            }

            return {
                filters,
                page: 0
            }
        }, () => {
            this.handleFilterData(type)
        })
    }

    handleFilterData = (type) => {
        const sourceData = type === 'live' ? this.state.liveCopy : this.state.archiveCopy
        const includesId = (selectedValues, rowValue) => {
            if (!Array.isArray(selectedValues)) return false
            const selectedAsString = selectedValues.map((item) => String(item))
            return selectedAsString.includes(String(rowValue))
        }

        const getSelectedLabels = (selectedValues, lookupObj) => {
            if (!Array.isArray(selectedValues) || !lookupObj) return []
            return selectedValues
                .map((item) => lookupObj[item] || lookupObj[String(item)])
                .filter(Boolean)
                .map((item) => String(item).toLowerCase())
        }

        const normalizeText = (value) => String(value ?? '').trim().toLowerCase()

        const jobRoleLookup = {}
            ; (this.state.lookupData?.job_title || []).forEach((item) => {
                jobRoleLookup[item.id] = item.name
            })

        const externalLookup = {};
        (this.state.lookupData?.external || []).forEach((item) => {
            externalLookup[item.id] = item.name
        })

        const ownerRegionLookup = {}
            ; (this.state.lookupData?.owner_region_sector || []).forEach((item) => {
                ownerRegionLookup[item.id] = item.name
            })

        const sectorLookup = {}
            ; (this.state.lookupData?.subsector || []).forEach((item) => {
                sectorLookup[item.id] = item.name
            })

        const ownerDeliveryLookup = {}
            ; (this.state.ownerDelivery || []).forEach((item) => {
                ownerDeliveryLookup[item.id] = item.name
            })
            ; (this.state.lookupData?.owner_delivery || []).forEach((item) => {
                if (!item) return
                const id = item.id ?? item.owner_delivery_unit ?? item.name
                const name = item.name ?? item.owner_delivery_name ?? id
                if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                    ownerDeliveryLookup[id] = name
                    ownerDeliveryLookup[String(id)] = name
                }
            })
        if (Object.keys(ownerDeliveryLookup).length === 0 && this.state.owner_delivery_unit) {
            Object.keys(this.state.owner_delivery_unit).forEach((key) => {
                ownerDeliveryLookup[key] = this.state.owner_delivery_unit[key]
            })
        }
        ;[...(this.state.liveCopy || []), ...(this.state.archiveCopy || [])].forEach((row) => {
            const rowId = row?.owner_delivery_unit
            const rowName = row?.owner_delivery_name
            if (rowId !== null && typeof rowId !== 'undefined' && String(rowId).trim() !== '' && rowName) {
                ownerDeliveryLookup[rowId] = rowName
                ownerDeliveryLookup[String(rowId)] = rowName
            }
            if (rowName) {
                ownerDeliveryLookup[rowName] = rowName
            }
        })

        const marketSubverticalLookup = {}
            ; ((this.state.marketSubVertical && this.state.marketSubVertical.length > 0)
                ? this.state.marketSubVertical
                : (this.state.lookupData?.marketsubvertical || [])
            ).forEach((item) => {
                marketSubverticalLookup[item.id] = item.name
            })
            ;[...(this.state.liveCopy || []), ...(this.state.archiveCopy || [])].forEach((row) => {
                const rowId = row?.market_subvertical
                const rowName = row?.market_subvertical_name || row?.marketsubvertical_name
                if (rowId !== null && typeof rowId !== 'undefined' && String(rowId).trim() !== '' && rowName) {
                    marketSubverticalLookup[rowId] = rowName
                    marketSubverticalLookup[String(rowId)] = rowName
                }
                if (rowName) {
                    marketSubverticalLookup[rowName] = rowName
                }
            })

        const roleGroupLookup = {}
            ; (this.state.lookupData?.role_group || []).forEach((item) => {
                roleGroupLookup[item.id] = item.name
            })

        const activeFilters = Object.entries(this.state.filters).filter(([, value]) => {
            if (Array.isArray(value)) return value.length > 0
            if (typeof value === 'string') return value.trim().length > 0
            return value !== null && typeof value !== 'undefined' && value !== ''
        })

        if (activeFilters.length === 0) {
            this.setState(type === 'live' ? { live: sourceData } : { archive: sourceData })
            return
        }

        const filteredData = sourceData.filter((row) => {
            return activeFilters.every(([key, value]) => {
                if (Array.isArray(value)) {
                    if (key === 'job_roles') {
                        const selectedLabels = getSelectedLabels(value, jobRoleLookup)
                        const rowJobRoleName = String(row.job_roles || '').toLowerCase()
                        return includesId(value, row.job_title) || selectedLabels.includes(rowJobRoleName)
                    }
                    if (key === 'owner_region') {
                        const selectedLabels = getSelectedLabels(value, ownerRegionLookup)
                        const rowOwnerRegionName = String(row.owner_region_name || '').toLowerCase()
                        return includesId(value, row.owner_region) || selectedLabels.includes(rowOwnerRegionName)
                    }
                    if (key === 'owner_delivery_name' || key === 'owner_delivery_unit') {
                        const selectedLabels = getSelectedLabels(value, ownerDeliveryLookup)
                        const selectedValuesNormalized = [
                            ...new Set([
                                ...(Array.isArray(value) ? value.map((item) => normalizeText(item)) : []),
                                ...selectedLabels.map((item) => normalizeText(item))
                            ])
                        ]

                        const rowCandidates = []
                        if (Array.isArray(row.owner_delivery_unit)) {
                            rowCandidates.push(...row.owner_delivery_unit)
                        } else {
                            rowCandidates.push(row.owner_delivery_unit)
                        }
                        rowCandidates.push(row.owner_delivery_name)

                        return rowCandidates
                            .filter((item) => item !== null && typeof item !== 'undefined' && String(item).trim() !== '')
                            .some((item) => selectedValuesNormalized.includes(normalizeText(item)))
                    }
                    if (key === 'sector') {
                        const selectedLabels = getSelectedLabels(value, sectorLookup)
                        const rowSectorName = String(row.sector_name || '').toLowerCase()
                        return includesId(value, row.sector) || selectedLabels.includes(rowSectorName)
                    }
                    if (key === 'market_subvertical') {
                        const selectedLabels = getSelectedLabels(value, marketSubverticalLookup)
                        const selectedValuesNormalized = [
                            ...new Set([
                                ...(Array.isArray(value) ? value.map((item) => normalizeText(item)) : []),
                                ...selectedLabels.map((item) => normalizeText(item))
                            ])
                        ]

                        const rowCandidates = []
                        if (Array.isArray(row.market_subvertical)) {
                            rowCandidates.push(...row.market_subvertical)
                        } else {
                            rowCandidates.push(row.market_subvertical)
                        }
                        rowCandidates.push(row.market_subvertical_name)
                        rowCandidates.push(row.marketsubvertical_name)

                        return rowCandidates
                            .filter((item) => item !== null && typeof item !== 'undefined' && String(item).trim() !== '')
                            .some((item) => selectedValuesNormalized.includes(normalizeText(item)))
                    }
                    if (key === 'self_parent') {
                        const selectedLabels = getSelectedLabels(value, this.state.lineManagerLookup || {})
                        const rowLineManagerName = `${row.line_manager_first_name || ''} ${row.line_manager_last_name || ''}`.trim().toLowerCase()
                        return includesId(value, row.self_parent) || selectedLabels.includes(rowLineManagerName)
                    }
                    if (key === 'role_group_id') {
                        const selectedLabels = getSelectedLabels(value, roleGroupLookup)
                        const rowRoleGroups = Array.isArray(row.role_group_id) ? row.role_group_id : []
                        const rowRoleGroupNames = Array.isArray(row.role_group_names)
                            ? row.role_group_names.map((item) => String(item).toLowerCase())
                            : []
                        return rowRoleGroups.some((roleGroupId) => includesId(value, roleGroupId))
                            || rowRoleGroupNames.some((name) => selectedLabels.includes(name))
                    }

                    if (key === 'external') {
                        const selectedLabels = getSelectedLabels(value, externalLookup)
                        const rowExternalName = String(row.external || '').toLowerCase()
                        return includesId(value, row.external) || selectedLabels.includes(rowExternalName)
                    }

                    const rowValue = row[key]
                    if (Array.isArray(rowValue)) {
                        return rowValue.some((item) => includesId(value, item))
                    }
                    return includesId(value, rowValue)
                }

                const rowValue = row[key]
                if (rowValue === null || typeof rowValue === 'undefined') return false

                if (typeof rowValue === 'string') {
                    return rowValue.toLowerCase().includes(value.toString().toLowerCase())
                }
                return rowValue.toString().includes(value.toString())
            })
        })

        this.setState(type === 'live' ? { live: filteredData } : { archive: filteredData })
    }

    getFilters(column, type) {
        const filterKeyMap = {
            owner_region_name: 'owner_region',
            owner_delivery_name: 'owner_delivery_name',
            market_subvertical_name: 'market_subvertical',
            sector_name: 'sector',
            role_group_name: 'role_group_id',
            payrole_process_name: 'payrole_process'
        }

        if (this.props.byEmployees) {
            filterKeyMap['external_name'] = 'external'
        }
        const filterKey = filterKeyMap[column.field] || column.field

        const ownerDeliveryOptions = (() => {
            const lookupOwnerDelivery = Array.isArray(this.state.lookupData?.owner_delivery)
                ? this.state.lookupData.owner_delivery
                : []
            const normalized = []

            if (lookupOwnerDelivery.length > 0) {
                lookupOwnerDelivery.forEach((item) => {
                    if (!item) return
                    const id = item.id ?? item.owner_delivery_unit ?? item.name
                    const name = item.name ?? item.owner_delivery_name ?? id
                    if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                        normalized.push({ id, name: String(name) })
                    }
                })
            } else {
                ; (this.state.ownerDelivery || []).forEach((item) => {
                    if (!item) return
                    const id = item.id ?? item.owner_delivery_unit ?? item.name
                    const name = item.name ?? item.owner_delivery_name ?? id
                    if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                        normalized.push({ id, name: String(name) })
                    }
                })

                Object.keys(this.state.owner_delivery_unit || {}).forEach((key) => {
                    normalized.push({ id: key, name: String(this.state.owner_delivery_unit[key]) })
                })

                    ;[...(this.state.liveCopy || []), ...(this.state.archiveCopy || [])].forEach((row) => {
                        const id = row?.owner_delivery_unit ?? row?.owner_delivery_name
                        const name = row?.owner_delivery_name ?? row?.owner_delivery_unit
                        if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                            normalized.push({ id, name: String(name) })
                        }
                    })
            }

            const byId = {}
            normalized.forEach((item) => {
                const key = String(item.id).trim()
                if (!byId[key]) {
                    byId[key] = { id: item.id, name: item.name || String(item.id) }
                }
            })

            const byName = {}
            Object.values(byId).forEach((item) => {
                const nameKey = String(item.name || item.id).trim().toLowerCase()
                if (!byName[nameKey]) {
                    byName[nameKey] = item
                }
            })

            return Object.values(byName).sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        })()

        const marketSubverticalOptions = (() => {
            const normalized = []

                ; (this.state.marketSubVertical || []).forEach((item) => {
                    if (!item) return
                    const id = item.id ?? item.market_subvertical ?? item.name
                    const name = item.name ?? item.market_subvertical_name ?? item.marketsubvertical_name ?? id
                    if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                        normalized.push({ id, name: String(name) })
                    }
                })

                ; (this.state.lookupData?.marketsubvertical || []).forEach((item) => {
                    if (!item) return
                    const id = item.id ?? item.market_subvertical ?? item.name
                    const name = item.name ?? item.market_subvertical_name ?? item.marketsubvertical_name ?? id
                    if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                        normalized.push({ id, name: String(name) })
                    }
                })

                ;[...(this.state.liveCopy || []), ...(this.state.archiveCopy || [])].forEach((row) => {
                    const id = row?.market_subvertical ?? row?.market_subvertical_name ?? row?.marketsubvertical_name
                    const name = row?.market_subvertical_name ?? row?.marketsubvertical_name ?? row?.market_subvertical
                    if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                        normalized.push({ id, name: String(name) })
                    }
                })

            const byId = {}
            normalized.forEach((item) => {
                const key = String(item.id)
                if (!byId[key]) {
                    byId[key] = { id: item.id, name: item.name || String(item.id) }
                }
            })

            return Object.values(byId).sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        })()

        const lineManagerOptions = (() => {
            const normalized = []

                ; (this.state.lineManagerArray || []).forEach((item) => {
                    if (!item) return
                    const id = item.id
                    const name = item.name
                    if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                        normalized.push({ id, name: String(name || '') })
                    }
                })

            Object.keys(this.state.lineManagerLookup || {}).forEach((key) => {
                normalized.push({ id: key, name: String(this.state.lineManagerLookup[key] || '') })
            })

            const byId = {}
            normalized.forEach((item) => {
                const key = String(item.id).trim()
                if (!byId[key]) {
                    byId[key] = { id: item.id, name: item.name || String(item.id) }
                }
            })

            const byName = {}
            Object.values(byId).forEach((item) => {
                const nameKey = String(item.name || item.id).trim().toLowerCase()
                if (!byName[nameKey]) {
                    byName[nameKey] = item
                }
            })

            return Object.values(byName).sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        })()

        const payroleOptions = (() => {
            const lookupPayroles = Array.isArray(this.state.lookupData?.payrole_process)
                ? this.state.lookupData.payrole_process
                : []
            const normalized = []

            if (lookupPayroles.length > 0) {
                lookupPayroles.forEach((item) => {
                    if (!item) return
                    const id = item.id ?? item.payrole_process ?? item.name
                    const name = item.name ?? item.payrole_process_name ?? id
                    if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                        normalized.push({ id, name: String(name) })
                    }
                })
            } else {
                ; (this.state.payroleArray || []).forEach((item) => {
                    if (!item) return
                    const id = item.id ?? item.payrole_process ?? item.name
                    const name = item.name ?? item.payrole_process_name ?? id
                    if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                        normalized.push({ id, name: String(name) })
                    }
                })

                    ;[...(this.state.liveCopy || []), ...(this.state.archiveCopy || [])].forEach((row) => {
                        const id = row?.payrole_process ?? row?.payrole_process_name
                        const name = row?.payrole_process_name ?? row?.payrole_process
                        if (id !== null && typeof id !== 'undefined' && String(id).trim() !== '') {
                            normalized.push({ id, name: String(name) })
                        }
                    })
            }

            const byId = {}
            normalized.forEach((item) => {
                const key = String(item.id).trim()
                if (!byId[key]) {
                    byId[key] = { id: item.id, name: item.name || String(item.id) }
                }
            })

            const byName = {}
            Object.values(byId).forEach((item) => {
                const nameKey = String(item.name || item.id).trim().toLowerCase()
                if (!byName[nameKey]) {
                    byName[nameKey] = item
                }
            })

            return Object.values(byName).sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        })()

        if (['start_date', 'end_date', 'date_created'].includes(column.field)) {
            return <TextField
                size='small'
                id={filterKey}
                defaultValue={this.state.filters[filterKey]}
                disabled={this.state.filtersDisabled}
                type='date'
                variant="standard"
                onChange={(e) => this.handleFilterChange(e, type)}
            />
        }
        else if (column.field === 'id') {
            return <TextField
                size='small'
                type='number'
                id={filterKey}
                onChange={(e) => this.handleFilterChange(e, type)}
                defaultValue={this.state.filters[filterKey]}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" disabled={this.state.filtersDisabled}>
                            <FilterListIcon fontSize='small' />
                        </InputAdornment>
                    ),
                }}
                variant="standard"
            />

        }
        else if (column.field === 'emp_no') {
            return <TextField
                size='small'
                type='text'
                id={filterKey}
                onChange={(e) => this.handleFilterChange(e, type)}
                defaultValue={this.state.filters[filterKey]}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" disabled={this.state.filtersDisabled}>
                            <FilterListIcon fontSize='small' />
                        </InputAdornment>
                    ),
                }}
                variant="standard"
            />

        }
        else if (column.field === 'owner_delivery_name') {
            const ownerDeliveryLookup = {}
            ownerDeliveryOptions.forEach((item) => {
                ownerDeliveryLookup[item.id] = item.name
                ownerDeliveryLookup[String(item.id)] = item.name
            })

            const selectedValues = (Array.isArray(this.state.filters.owner_delivery_unit) && this.state.filters.owner_delivery_unit.length > 0)
                ? this.state.filters.owner_delivery_unit
                : (Array.isArray(this.state.filters.owner_delivery_name) ? this.state.filters.owner_delivery_name : [])

            return <Select
                size='small'
                multiple
                autoWidth
                name={'owner_delivery_unit'}
                id={'owner_delivery_unit'}
                onChange={(e) => this.handleFilterChange(e, type)}
                value={selectedValues}
                variant="standard"
                renderValue={(selected) => <Box fontSize={"12px"}>{selected.map((id) => ownerDeliveryLookup[id] || ownerDeliveryLookup[String(id)]).filter(Boolean).join(', ')}</Box>}
            >
                {ownerDeliveryOptions.map((ele, i) => {
                    const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                    return <MenuItem key={ele.id || i} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                })}
            </Select>
        }
        else if (column.field === 'payrole_process_name' || filterKey === 'payrole_process') {
            const payroleLabelLookup = {}
            payroleOptions.forEach((item) => {
                payroleLabelLookup[item.id] = item.name
                payroleLabelLookup[String(item.id)] = item.name
            })

            const selectedValues = Array.isArray(this.state.filters.payrole_process) ? this.state.filters.payrole_process : []

            return <Select
                size='small'
                multiple
                autoWidth
                name={'payrole_process'}
                id={'payrole_process'}
                onChange={(e) => this.handleFilterChange(e, type)}
                value={selectedValues}
                variant="standard"
                renderValue={(selected) => <Box fontSize={"12px"}>{selected.map((id) => payroleLabelLookup[id] || payroleLabelLookup[String(id)]).filter(Boolean).join(', ')}</Box>}
            >
                {payroleOptions.map((ele, i) => {
                    const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                    return <MenuItem key={ele.id || i} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                })}
            </Select>
        }
        else if (filterKey === 'job_roles' || filterKey === 'market_subvertical' || filterKey === 'owner_region' || filterKey === 'owner_delivery_name' || filterKey === 'sector' || filterKey === 'self_parent' || filterKey === 'role_group_id' || filterKey === 'external') {
            return <Select
                size='small'
                multiple
                autoWidth
                disabled={this.state.filtersDisabled}
                name={filterKey}
                id={filterKey}
                onChange={(e) => this.handleFilterChange(e, type)}
                value={this.state.filters[filterKey] || []}
                variant="standard"
                renderValue={(selected) => {
                    const selectedValues = Array.isArray(selected) ? selected : []
                    // const isChecked = (optionId) => selectedValues.map((item) => String(item)).includes(String(optionId))

                    const jobRoleLookup = {}
                    if (Array.isArray(this.state.lookupData?.job_title)) {
                        this.state.lookupData.job_title.forEach((item) => {
                            jobRoleLookup[item.id] = item.name
                        })
                    }

                    const ownerRegionLookup = {}
                    if (Array.isArray(this.state.lookupData?.owner_region_sector)) {
                        this.state.lookupData.owner_region_sector.forEach((item) => {
                            ownerRegionLookup[item.id] = item.name
                        })
                    }

                    const sectorLookup = {}
                    if (Array.isArray(this.state.lookupData?.subsector)) {
                        this.state.lookupData.subsector.forEach((item) => {
                            sectorLookup[item.id] = item.name
                        })
                    }

                    const ownerDeliveryLookup = {}
                    ownerDeliveryOptions.forEach((item) => {
                        ownerDeliveryLookup[item.id] = item.name
                        ownerDeliveryLookup[String(item.id)] = item.name
                        ownerDeliveryLookup[item.name] = item.name
                    })

                    const marketSubverticalLookup = {}
                    marketSubverticalOptions.forEach((item) => {
                        marketSubverticalLookup[item.id] = item.name
                        marketSubverticalLookup[String(item.id)] = item.name
                        marketSubverticalLookup[item.name] = item.name
                    })

                    const roleGroupLookup = {}
                    if (Array.isArray(this.state.lookupData?.role_group)) {
                        this.state.lookupData.role_group.forEach((item) => {
                            roleGroupLookup[item.id] = item.name
                        })
                    }

                    const externalLookup = {}
                    if (Array.isArray(this.state.lookupData?.external) && this.props.byEmployees) {
                        this.state.lookupData.external.forEach((item) => {
                            externalLookup[item.id] = item.name
                        })
                    }

                    let labelLookup = {}
                    if (filterKey === 'job_roles') {
                        labelLookup = jobRoleLookup
                    } else if (filterKey === 'market_subvertical') {
                        labelLookup = marketSubverticalLookup
                    } else if (filterKey === 'owner_region') {
                        labelLookup = ownerRegionLookup
                    } else if (filterKey === 'owner_delivery_name') {
                        labelLookup = ownerDeliveryLookup
                    } else if (filterKey === 'sector') {
                        labelLookup = sectorLookup
                    } else if (filterKey === 'self_parent') {
                        labelLookup = this.state.lineManagerLookup || {}
                    } else if (filterKey === 'role_group_id') {
                        labelLookup = roleGroupLookup
                    } else if (filterKey === 'external') {
                        labelLookup = externalLookup
                    }

                    const labels = selectedValues.map((id) => labelLookup[id] || id)
                    return <Box fontSize={"12px"}>{labels.join(', ')}</Box>
                }}
            >
                {filterKey === 'job_roles' ?
                    [...(this.state.lookupData.job_title || [])]
                        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                        .map((ele, i) => {
                            const selectedValues = Array.isArray(this.state?.filters[filterKey]) ? this.state.filters[filterKey] : []
                            const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                            return <MenuItem key={i} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                        }) :
                    filterKey === 'market_subvertical' ?
                        marketSubverticalOptions.map((ele, i) => {
                            const selectedValues = Array.isArray(this.state?.filters[filterKey]) ? this.state.filters[filterKey] : []
                            const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                            return <MenuItem key={ele.id || i} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                        }) :
                        filterKey === 'owner_region' ?
                            [...(this.state.lookupData.owner_region_sector || [])]
                                .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                .map((ele, i) => {
                                    const selectedValues = Array.isArray(this.state?.filters[filterKey]) ? this.state.filters[filterKey] : []
                                    const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                                    return <MenuItem key={ele.id} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                                }) :
                            filterKey === 'owner_delivery_name' ?
                                ownerDeliveryOptions.map((ele, i) => {
                                    const selectedValues = Array.isArray(this.state?.filters[filterKey]) ? this.state.filters[filterKey] : []
                                    const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                                    return <MenuItem key={ele.id || i} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                                }) :
                                filterKey === 'self_parent' ?
                                    lineManagerOptions.map((ele, i) => {
                                        const selectedValues = Array.isArray(this.state?.filters[filterKey]) ? this.state.filters[filterKey] : []
                                        const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                                        return <MenuItem key={ele.id || i} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                                    }) :
                                    filterKey === 'role_group_id' ?
                                        [...(this.state.lookupData.role_group || [])]
                                            .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                            .map((ele, i) => {
                                                const selectedValues = Array.isArray(this.state?.filters[filterKey]) ? this.state.filters[filterKey] : []
                                                const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                                                return <MenuItem key={ele.id || i} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                                            })

                                        :
                                        filterKey === 'external' ?
                                            [...(this.state.lookupData.external || [])]
                                                .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                                .map((ele, i) => {
                                                    const selectedValues = Array.isArray(this.state?.filters[filterKey]) ? this.state.filters[filterKey] : []
                                                    const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                                                    return <MenuItem key={ele.id} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                                                }) :
                                            [...(this.state.lookupData.subsector || [])]
                                                .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                                .map((ele, i) => {
                                                    const selectedValues = Array.isArray(this.state?.filters[filterKey]) ? this.state.filters[filterKey] : []
                                                    const checked = selectedValues.map((item) => String(item)).includes(String(ele.id))
                                                    return <MenuItem key={ele.id} value={ele.id}><Checkbox size='small' checked={checked} /><ListItemText primary={ele.name} /></MenuItem>
                                                })
                }
            </Select>
        }
        else {
            return <TextField
                size='small'
                id={filterKey}
                disabled={this.state.filtersDisabled}
                onChange={(e) => this.handleFilterChange(e, type)}
                defaultValue={this.state.filters[filterKey]}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <FilterListIcon fontSize='small' />
                        </InputAdornment>
                    ),
                }}
                variant="standard"
            />
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
    }

    handleSort = (column, type) => {
        let data = this.state.tabValue === 0 ? this.state.live : this.state.archive
        let order = this.state.order
        let orderBy = this.state.orderBy
        if (orderBy === column && order === 'asc') {
            order = 'desc'
        } else {
            order = 'asc'
        }
        //eslint-disable-next-line 
        let data1 = data.sort((a, b) => {
            if (order === 'desc') {
                if (column === 'owner_region') {
                    return a['owner_region_name'] > b['owner_region_name'] ? -1 : 1
                } else if (column === 'sector') {
                    return a['sector_name'] > b['sector_name'] ? -1 : 1
                } else if (column === 'market_subvertical') {
                    return this.state.market_subvertical[a[column]] > this.state.market_subvertical[b[column]] ? -1 : 1
                } else if (column === 'first_name' || column === 'last_name' || column === 'email') {
                    return a[column].toLowerCase() > b[column].toLowerCase() ? -1 : 1
                } else {
                    return a[column] > b[column] ? -1 : 1
                }
            }
            if (order === 'asc') {
                if (column === 'owner_region') {
                    return a['owner_region_name'] < b['owner_region_name'] ? -1 : 1
                } else if (column === 'sector') {
                    return a['sector_name'] < b['sector_name'] ? -1 : 1
                } else if (column === 'market_subvertical') {
                    return this.state.market_subvertical[a[column]] < this.state.market_subvertical[b[column]] ? -1 : 1
                } else if (column === 'first_name' || column === 'last_name' || column === 'email') {
                    return a[column].toLowerCase() < b[column].toLowerCase() ? -1 : 1
                } else {
                    return a[column] < b[column] ? -1 : 1
                }
            }
        })
        if (this.state.tabValue === 0) {
            this.setState({ live: data1, order, orderBy: column })
        } else {
            this.setState({ archive: data1, order, orderBy: column })
        }
    }

    linkSubContractor() {
        if (!this.state.selectedSubcontractor) {
            this.props.enqueueSnackbar('Please select a External!', {
                variant: 'warning'
            })
            return
        } else {
            this.setState({
                linkDisabled: true
            })
            Service.post('/api/subcontractor/link_employee_to_subcontractor/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    employee_id: this.state.postData.id,
                    subcontractor_id: this.state.selectedSubcontractor.id
                }
            })
                .then(res => {
                    this.props.enqueueSnackbar('External linked successfully!', {
                        variant: 'success'
                    })
                    this.setState({
                        linkSubContractorDialog: false,
                        selectedSubcontractor: null,
                        linkDisabled: false
                    }, () => {
                        this.fetchOps()
                    })
                })
                .catch(error => {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    })
                })
        }
    }

    updateSubContractor() {
        if (!this.state.selectedSubcontractor) {
            this.props.enqueueSnackbar('Please select a External!', {
                variant: 'warning'
            })
            return
        } else {
            this.setState({
                linkDisabled: true
            })
            Service.post('/api/subcontractor/link_employee_to_subcontractor/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    employee_id: this.state.postData.id,
                    subcontractor_id: this.state.selectedSubcontractor.id
                }
            })
                .then(res => {
                    this.props.enqueueSnackbar('External updated successfully!', {
                        variant: 'success'
                    })
                    this.setState({
                        linkSubContractorDialog: false,
                        selectedSubcontractor: null,
                        linkDisabled: false
                    }, () => {
                        this.fetchOps()
                    })
                })
                .catch(error => {
                    console.log(error)
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    })
                })
        }
    }

    openLinkManagerDialog(event, rowData) {
        if (rowData.self_parent) {
            for (let index = 0; index < this.state.linkEmployeeData.length; index++) {
                const element = this.state.linkEmployeeData[index];
                if (element.id === rowData.self_parent) {
                    this.setState({
                        selectedLineManager: element
                    })
                }
            }
        } else {
            this.setState({
                selectedLineManager: null
            })
        }
        this.setState({
            postData: rowData,
            linkLineManagerDialog: true,
        })
    }

    reloadEmployeeData(type) {
        this.fetchOps()
    }

    handleLeaveRestrictionClose() {
        this.setState({ leaveRestrictionDialog: false, selectedUser: null })
    }

    openLeaveRestriction(rowData) {
        this.setState({ selectedUser: rowData, leaveRestrictionDialog: true })
    }

    getR12Data() {
        this.setState({ r12Loading: true, r12Dialog: true, r12Data: [] })
        Service.get(`/api/users/get_employees_not_in_ptd/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({ r12Data: res.data, r12Loading: false })
            })
            .catch(error => {
                console.log(error)
                this.setState({ r12Loading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    addSelectedUser(userData) {
        const findLookupItem = (options, values) => {
            const lookupValues = values.flatMap((value) => {
                if (value === null || typeof value === 'undefined') return []
                if (typeof value === 'object') {
                    return [value.id, value.value, value.name, value.label]
                }
                return [value]
            }).filter((value) => value !== null && typeof value !== 'undefined' && String(value).trim() !== '')

            return (options || []).find((item) => lookupValues.some((value) =>
                String(item.id) === String(value)
                || String(item.name || '').trim().toLowerCase() === String(value).trim().toLowerCase()
                || String(item.label || '').trim().toLowerCase() === String(value).trim().toLowerCase()
            ))
        }

        const selectedJobTitle = (this.state.lookupData?.job_title || []).find((item) =>
            String(item.id) === String(userData.role_id) || String(item.id) === String(userData.role)
            || String(item.name).trim().toLowerCase() === String(userData.job_title || '').trim().toLowerCase()
        )
        const selectedPayroleProcess = findLookupItem(this.state.lookupData?.payrole_process, [
            userData.payrole_process_id,
            userData.payrole_process,
            userData.payrole_process_name,
            userData.payroll_process,
            userData.payroll_process_name,
        ])
        const selectedOwnerRegion = (this.state.lookupData?.owner_region_sector || []).find((item) =>
            String(item.id) === String(userData.owner_region || userData.owner_region_id || userData.region)
            || String(item.name).trim().toLowerCase() === String(userData.owner_region_name || '').trim().toLowerCase()
        )
        const selectedOwnerDelivery = (this.state.lookupData?.owner_delivery || []).find((item) =>
            String(item.id) === String(userData.owner_delivery_unit || userData.owner_delivery_id || userData.owner_delivery || userData.division)
            || String(item.name).trim().toLowerCase() === String(userData.owner_delivery_name || userData.owner_delivery_unit || '').trim().toLowerCase()
        )
        const selectedSector = (this.state.lookupData?.subsector || []).find((item) =>
            String(item.id) === String(userData.subsector || userData.sector || userData.subsector_id)
            || String(item.name).trim().toLowerCase() === String(userData.subsector_name || userData.sector_name || userData.subsector || userData.sector || '').trim().toLowerCase()
        )
        const selectedMarketSubvertical = (this.state.lookupData?.market_subvertical || this.state.lookupData?.marketsubvertical || []).find((item) =>
            String(item.id) === String(userData.market_subvertical || userData.marketsubvertical || userData.market_subvertical_id || userData.division)
            || String(item.name).trim().toLowerCase() === String(userData.market_subvertical_name || userData.marketsubvertical_name || '').trim().toLowerCase()
        )
        const selectedCrm = findLookupItem(this.state.crmData, [
            userData.crm,
            userData.crm_id,
            userData.crm_name,
        ])

        if (!selectedJobTitle) {
            this.props.enqueueSnackbar(
                `Job role "${userData.job_title || userData.role_id || 'Unknown'}" does not exist in the current Roles list and will not be prefilled.`,
                { variant: 'warning' }
            )
        }

        const candidateData = userData.last_candidate || {}
        const employeeNameParts = String(userData.ptd_employee_name || '').trim().split(' ').filter(Boolean)
        const firstName = userData.first_name || candidateData.first_name || userData.candidate_first_name || employeeNameParts[0] || ''
        const lastName = userData.surname || userData.last_name || candidateData.last_name || userData.candidate_last_name || employeeNameParts.slice(1).join(' ') || ''

        const postData = {
            ...this.state.postData,
            emp_no: userData.employee_number || userData.bbuk_number || null,
            first_name: firstName,
            last_name: lastName,
            email: userData.email_address || null,
            start_date: userData.latest_start_date || null,
            job_title: selectedJobTitle ? selectedJobTitle.id : null,
            job_roles: selectedJobTitle ? selectedJobTitle.name : null,
            payrole_process_id: selectedPayroleProcess?.id || userData.payrole_process_id || userData.payrole_process?.id || userData.payrole_process || null,
            payrole_process: selectedPayroleProcess?.id || userData.payrole_process_id || userData.payrole_process?.id || userData.payrole_process || null,
            payrole_process_name: selectedPayroleProcess?.name || userData.payrole_process_name || userData.payroll_process_name || userData.payrole_process?.name || userData.payrole_process?.label || null,
            r12_job_title_name: userData.job_title || '',
            owner_region_id: selectedOwnerRegion?.id || userData.owner_region || userData.owner_region_id || null,
            owner_region_name: selectedOwnerRegion?.name || userData.owner_region_name || null,
            owner_delivery_id: selectedOwnerDelivery?.id || userData.owner_delivery_unit || userData.owner_delivery_id || null,
            owner_delivery_name: selectedOwnerDelivery?.name || userData.owner_delivery_name || userData.owner_delivery_unit || null,
            sector_id: selectedSector?.id || userData.subsector || userData.sector || userData.subsector_id || userData.discipline || null,
            sector_name: selectedSector?.name || userData.subsector_name || userData.sector_name || userData.subsector || userData.sector || null,
            market_subvertical: selectedMarketSubvertical?.id || userData.marketsubvertical || userData.market_subvertical || userData.market_subvertical_id || null,
            market_subvertical_name: selectedMarketSubvertical?.name || userData.marketsubvertical_name || userData.market_subvertical_name || null,
            crm: selectedCrm?.id || userData.crm || userData.crm_id || null,
            crm_name: selectedCrm?.name || userData.crm_name || null,
            role_group_id: Array.isArray(userData.role_group_id) ? userData.role_group_id[0] : userData.role_group_id || userData.role_group || null,
            role_group_name: Array.isArray(userData.role_group_names) ? userData.role_group_names[0] : userData.role_group_name || null,
            end_date: userData.end_date || null,
            availability: userData.availability || null,
        }
        if (userData.bbuk_number) {
            this.setState({
                isAtr: true
            })
            postData['atr_record'] = userData.id || null
        }

        console.log(postData)

        this.setState({ postData }, () => {
            this.setState({ addUser: true, type: 'add', r12Dialog: false, atrDialog: false })
        })
    }

    unarchiveEmployee() {
        Service.patch(`/api/ptd/employees/unarchive_employee/?emp_id=${this.state.selectedUser.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({ unarchiveEmployeeDialog: false })
                this.fetchOps()
                this.props.enqueueSnackbar('Employee Unarchived Successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                console.log(error)
                this.setState({ unarchiveEmployeeDialog: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    createEmployeeHistory() {
        if (!this.state.typeOfExperience) {
            this.props.enqueueSnackbar('Please select a type of experience', {
                variant: 'warning'
            });
            return;
        }
        if (!this.state.yearsOfExperience || this.state.yearsOfExperience <= 0) {
            this.props.enqueueSnackbar('Please enter years of experience', {
                variant: 'warning'
            });
            return;
        }
        if (this.state.typeOfExperience.id === 'role_history') {
            if (!this.state.selectedHistoryRole) {
                this.props.enqueueSnackbar('Please select a role for experience', {
                    variant: 'warning'
                });
                return;
            }
        }
        if (this.state.typeOfExperience.id === 'client_history') {
            if (!this.state.selectedHistoryClient?.id) {
                this.props.enqueueSnackbar('Please select a client for experience', {
                    variant: 'warning'
                });
                return;
            }
        }
        if (this.state.typeOfExperience.id === 'descipline_history') {
            if (!this.state.selectedHistoryDescipline?.id) {
                this.props.enqueueSnackbar('Please select a discipline for experience', {
                    variant: 'warning'
                });
                return;
            }
        }
        this.setState({ createExperienceDisabled: true })
        let data = {}
        if (this.state.typeOfExperience.id === 'role_history') {
            data = {
                employee_id: this.state.selectedUser.id,
                role_id: this.state.selectedHistoryRole?.id,
                key: this.state.typeOfExperience.id,
                years_of_experience: this.state.yearsOfExperience,
            }
        } else if (this.state.typeOfExperience.id === 'client_history') {
            data = {
                employee_id: this.state.selectedUser.id,
                client_id: this.state.selectedHistoryClient?.id,
                key: this.state.typeOfExperience.id,
                years_of_experience: this.state.yearsOfExperience,
            }
        } else if (this.state.typeOfExperience.id === 'descipline_history') {
            data = {
                employee_id: this.state.selectedUser.id,
                descipline_id: this.state.selectedHistoryDescipline?.id,
                key: this.state.typeOfExperience.id,
                years_of_experience: this.state.yearsOfExperience,
            }
        }
        else {
            data = {
                employee_id: this.state.selectedUser.id,
                key: this.state.typeOfExperience.id,
                years_of_experience: this.state.yearsOfExperience,
            }
        }
        Service.patch(`/api/past/employee/history/create_emp_past_history/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data
        })
            .then(res => {
                this.setState({ createExperienceDisabled: false, addExperienceDialog: false, typeOfExperience: null, yearsOfExperience: 0, selectedHistoryRole: null, selectedHistoryClient: null, selectedHistoryDescipline: null })
                this.getEmployeeHistory(this.state.selectedUser)
                this.props.enqueueSnackbar('Employee History Created Successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                console.log(error)
                this.setState({ createExperienceDisabled: false, addExperienceDialog: false, typeOfExperience: null, yearsOfExperience: 0, selectedHistoryRole: null, selectedHistoryClient: null, selectedHistoryDescipline: null })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    editEmployeeHistory() {
        console.log(this.state.selectedPastHistoryData)
        if (!this.state.yearsOfExperience) {
            this.props.enqueueSnackbar('Please enter years of experience', {
                variant: 'warning'
            });
            return;
        }
        let data = {
            employee_id: this.state.selectedUser.id,
            key: this.state.selectedPastHistoryData.type,
            years_of_experience: this.state.yearsOfExperience,
        }
        if (this.state.selectedPastHistoryData.type === 'role_history') {
            data.role = this.state.selectedPastHistoryData.role;
            data.role_id = this.state.lookupData?.job_title.map(jobTitle => jobTitle.name === this.state.selectedPastHistoryData.role ? jobTitle.id : null).filter(Boolean)[0];
        }
        if (this.state.selectedPastHistoryData.type === 'client_history') {
            data.client_id = this.state.selectedPastHistoryData?.client_id;
        }
        if (this.state.selectedPastHistoryData.type === 'descipline_history') {
            data.descipline_id = this.state.selectedPastHistoryData?.descipline_id;
        }
        console.log(data)
        Service.patch(`/api/past/employee/history/create_emp_past_history/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data
        })
            .then(res => {
                this.setState({ createExperienceDisabled: false, addExperienceDialog: false, typeOfExperience: null, yearsOfExperience: 0, isEdit: false, selectedPastHistoryData: null })
                this.getEmployeeHistory(this.state.selectedUser)
                this.props.enqueueSnackbar('Employee History Edited Successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                console.log(error)
                this.setState({ createExperienceDisabled: false, addExperienceDialog: false, typeOfExperience: null, yearsOfExperience: 0, isEdit: false, selectedPastHistoryData: null })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })

    }

    getEmployeeHistory(row) {
        this.setState({ employeeHistoryDialog: true, selectedUser: row, employeeHistoryLoading: true })
        Service.get(`/api/past/employee/history/get_employee_history/?emp_id=${row.id}`, {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                this.setState({ employeeHistoryLoading: false, employeeHistoryData: res.data })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    editExperience(index, history) {
        this.setState({
            selectedPastHistoryData: history,
            yearsOfExperience: history.years_of_experience,
            isEdit: true,
            addExperienceDialog: true,
        })
    }

    getEmployeeExportParams(selectedFilterKeys = null) {
        const params = new URLSearchParams()
        const { filters } = this.state
        const allowedFilterKeys = Array.isArray(selectedFilterKeys) ? selectedFilterKeys : Object.keys(filters)
        const jobRoleIdsByName = this.state.jobRoles.reduce((lookup, role) => {
            lookup[role.job_roles] = role.id
            return lookup
        }, {})

        Object.keys(filters).forEach((key) => {
            if (!allowedFilterKeys.includes(key)) {
                return
            }

            const value = filters[key]

            if (Array.isArray(value)) {
                if (value.length > 0) {
                    const exportKey = key === 'job_roles' ? 'job_title' : key === 'role_group_id' ? 'role_group'
                        : key === 'owner_delivery_name' ? 'owner_delivery_unit' : key
                    const exportValue = key === 'job_roles' ? value.map((jobRole) => {
                        const mappedRoleId = jobRoleIdsByName[jobRole]
                        return mappedRoleId || jobRole
                    }).filter((item) => item !== null && typeof item !== 'undefined' && String(item).trim() !== '')
                        : value

                    if (exportValue.length > 0) {
                        params.append(exportKey, exportValue.join(','))
                    }
                }
                return
            }

            if (value !== undefined && value !== null && value !== '') {
                params.append(key, value)
            }
        })

        params.append('employee_status', this.state.tabValue === 0 ? 'live' : 'archive')

        return params.toString()
    }

    excelExport(selectedFilterKeys = null) {
        this.setState({ excelExportDisabled: true })
        const queryParams = this.getEmployeeExportParams(selectedFilterKeys)
        let exportApi = queryParams ? `/api/prp/template/employee_list_export/?${queryParams}` : `/api/prp/template/employee_list_export/`

        if (this.props.isExternal) {
            exportApi += `&employee_type=external&subcontractor_id=${this.props.subcontractor.id}`
        }

        Service.get(exportApi, {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                this.props.enqueueSnackbar('Employee list exported successfully', {
                    variant: 'success'
                });
                this.setState({ excelExportDisabled: false })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.setState({ excelExportDisabled: false })
            })
    }

    handleExportFilterToggle = (key) => {
        this.setState((prevState) => ({
            exportFilterSelection: {
                ...prevState.exportFilterSelection,
                [key]: !prevState.exportFilterSelection[key]
            }
        }))
    }

    handleExportFilterSubmit = () => {
        const selectedFilterKeys = Object.keys(this.state.exportFilterSelection).filter((key) => this.state.exportFilterSelection[key])
        this.setState({ exportFilterDialogOpen: false }, () => {
            this.excelExport(selectedFilterKeys)
        })
    }

    linkBusinessUnit() {
        if (!this.state.selectedBusinessUnit) {
            this.props.enqueueSnackbar('Please select a Business Unit!', {
                variant: 'warning'
            })
            return
        } else {
            this.setState({
                linkDisabled: true
            })
            Service.patch(`/api/ptd/employees/link_employee_business_unit/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    employee_id: this.state.postData.id,
                    business_unit_id: this.state.selectedBusinessUnit.id
                }
            })
                .then(res => {
                    this.setState({ linkBusinessUnitDialog: false, selectedBusinessUnit: null, linkDisabled: false }, () => {
                        this.props.enqueueSnackbar('Business Unit linked successfully!', {
                            variant: 'success'
                        });
                    });
                })
                .catch(error => {
                    console.log(error)
                    if (error.status === 403) {
                        this.props.enqueueSnackbar(error.data.message, {
                            variant: 'warning'
                        });
                    }
                    else if (error.status === 400) {
                        this.props.enqueueSnackbar(error.data.message, {
                            variant: 'warning'
                        });
                    } else {
                        this.props.enqueueSnackbar('Something went wrong!', {
                            variant: 'error'
                        });
                    }

                })
        }

    }

    openBusinessUnitDialog(row) {
        for (let index = 0; index < this.state.businessUnitDropdown.length; index++) {
            const element = this.state.businessUnitDropdown[index];
            if (element.id === row.business_unit) {
                this.setState({ selectedBusinessUnit: element });
                break;
            }
        }
        this.setState({
            postData: row,
            businessUnitDialog: true,
        })
    }

    importFromAtr() {
        Service.get(`/api/atr/records/get_atr_records/?status=1`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({ atrData: res.data }, () => {
                    this.setState({
                        atrDialog: true
                    })
                })
            })
            .catch(error => {
                console.log(error)
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                }
                else if (error.status === 400) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }

            })

    }

    openCommentDialog(row) {
        this.setState({
            selectedEmp: row,
            commentDialog: true
        });
    }

    commentDialogClose = () => {
        this.setState({
            commentDialog: false,
        });
    }

    updateComment(data) {
        var listKey = this.state.tabValue === 0 ? 'live' : 'archive';
        var employees = this.state[listKey];
        var index = employees.findIndex(item => item.id === data.emp);

        if (index === -1) return;

        employees[index].latest_comment = data;
        this.setState({ [listKey]: employees });
    }

    getArchiveReasons() {
        this.setState({ archiveReasonLoading: true });
        Service.get('/api/employee/archive/reason/get_emp_archive_reason_data/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({ archiveReasons: res.data, archiveReasonLoading: false })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.setState({ archiveReasonLoading: false });
            })
    }

    openAssignEndDate(row) {
        this.setState({
            postData: JSON.parse(JSON.stringify(row)),
            endDateDialog: true,
        }, () => {
            if (BUArchiveReasonEnable(row.bu_key)) {
                this.getArchiveReasons()
            }
        })
    }

    openArchiveConfirmation() {
        var postData = this.state.postData;
        if (!postData.end_date) {
            this.props.enqueueSnackbar('Please select End Date', {
                variant: 'warning'
            });
        } else if (BUArchiveReasonEnable(postData.bu_key) && !this.state.selectedArchiveReason) {
            this.props.enqueueSnackbar('Please select Archive Reason', {
                variant: 'warning'
            });
        } else {
            this.setState({ confirmationDialog: true });
        }
    }

    render() {
        const access = this.props.access.access

        const addDialogClose = () => {
            this.setState({
                addUser: false,
                postData: {
                    emp_no: null,
                    first_name: null,
                    last_name: null,
                    job_title: null,
                    email: null,
                    owner_region: null,
                    owner_delivery_unit: null,
                    sector: null,
                    market_subvertical: null,
                    role_group_id: null,
                    role_group_name: null,
                    start_date: null,
                    end_date: null
                },
                isAtr: false
            })
        }

        const exportCsv = (columnList, initialData) => {
            if (this.state.tabValue === 0) columnList = columnList.filter(column => column.field !== 'end_date');
            const columns = columnList.filter(columnDef => {
                return !columnDef.hidden && columnDef.field && columnDef.export !== false;
            });

            const data = initialData.map(rowData =>
                columns.map(columnDef => {
                    return columnDef.render ? columnDef.render(rowData) : columnDef.lookup ? columnDef.lookup[rowData[columnDef.field]] : rowData[columnDef.field];
                })
            );

            const builder = new CsvBuilder((this.state.tabValue === 0 ? "Live_Employees_Lists" : "Archive_Employees_Lists") + '.csv');
            builder
                .setDelimeter(',')
                .setColumns(columns.map(columnDef => columnDef.title))
                .addRows(data)
                .exportFile();
        };

        return (<>
            {this.state.isLoading ? <RotateCircleLoading color={getPrimaryColor()} /> :
                <div>
                    <Paper square >
                        <Tabs
                            value={this.state.tabValue}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={(e, newValue) => this.handleViewType(e, newValue)}
                            aria-label="Role Tabs"
                            centered >
                            <Tab label="Live" />
                            <Tab label="Archive" />
                        </Tabs>
                        <TabPanel value={this.state.tabValue} index={0}>
                            {this.state.tableLoading ? <RotateCircleLoading color={getPrimaryColor()} /> :
                                <div>
                                    <TableContainer component={Paper}>
                                        <Toolbar  >
                                            <Box display={'flex'} flexDirection={'row'} width={'100%'}>
                                                <Box display="flex" flexDirection='row' flexGrow={1} alignItems='center' >
                                                    <h2>Employees</h2>&emsp;&emsp;
                                                    {access.l4a && access.l4a.l4a_d && !this.props.byEmployees ?
                                                        <React.Fragment>
                                                            <Button
                                                                color='primary'
                                                                variant="outlined"
                                                                size="small"
                                                                onClick={() => this.setState({ dropZoneModal: true })}
                                                                style={{ marginRight: '10px', }}
                                                                startIcon={<UploadIcon fontSize='small' />}
                                                            >
                                                                Upload Employee Data Excel
                                                            </Button>

                                                            <Export allData={true} />
                                                        </React.Fragment> : null}
                                                </Box>
                                                <Box display={'flex'} flexDirection={"row"} justifyContent={'center'} alignItems={'center'}>
                                                    {access.l4a && access.l4a.l4a_b && !this.props.byEmployees ?
                                                        <React.Fragment>
                                                            <Button
                                                                color='primary'
                                                                variant="outlined"
                                                                size="small"
                                                                onClick={() => this.getR12Data()}
                                                                style={{ marginRight: '10px', }}
                                                                startIcon={<ImportExportIcon fontSize='small' />}
                                                            >
                                                                Import from R12
                                                            </Button>
                                                            {
                                                                !this.props.byEmployees &&
                                                                <Button
                                                                    color='primary'
                                                                    variant="outlined"
                                                                    size="small"
                                                                    onClick={() => this.setState({ addUser: true, type: 'add' })}
                                                                    startIcon={<AddIcon fontSize='small' />}
                                                                    style={{ marginRight: '10px', }}
                                                                >
                                                                    Add Employee
                                                                </Button>}
                                                        </React.Fragment> : null}
                                                    <Button
                                                        color='primary'
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => exportCsv(this.state.columns, this.state.live)}
                                                        startIcon={<GetAppIcon fontSize='small' />}
                                                    >
                                                        Export
                                                    </Button>
                                                    {!this.props.byEmployees && !this.props.subcontractor ?
                                                        <Box margin={1}>
                                                            <Button
                                                                color='primary'
                                                                variant="outlined"
                                                                size="small"
                                                                onClick={() => this.setState({ exportFilterDialogOpen: true })}
                                                            >
                                                                Export Current Project Allocation
                                                            </Button>
                                                        </Box> : null}
                                                </Box>
                                            </Box>
                                        </Toolbar>
                                        <Table aria-label="simple table" size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align='center'>
                                                        Actions
                                                    </TableCell>
                                                    {this.state.columns.filter((column) => column.field !== 'end_date').map((column) => (
                                                        <TableCell>
                                                            <TableSortLabel
                                                                active={this.state.orderBy === column.field}
                                                                direction={this.state.order === 'asc' ? 'asc' : 'desc'}
                                                                onClick={(e) => this.handleSort(column.field, this.state.tabValue)}
                                                            >
                                                                {column.title}
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    {
                                                        this.state.columns.filter((column) => column.field !== 'end_date').map((column) => (
                                                            <TableCell >
                                                                {this.getFilters(column, 'live')}
                                                            </TableCell>
                                                        ))
                                                    }
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(this.state.rowsPerPage > 0 ? this.state.live.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage) : this.state.live).map((row) => (
                                                    <TableRow key={row.name}>
                                                        <TableCell >
                                                            <Box display='flex' justifyContent={'center'} alignItems={'center'}>
                                                                <Tooltip title="Change History">
                                                                    <IconButton size='small' onClick={(event, rowData) => {
                                                                        this.setState({
                                                                            selectedEmp: row
                                                                        }, () => { this.getRegionChangeInfo(row); this.getPromotionHistory(row) })
                                                                    }}>
                                                                        <HistoryIcon fontSize='small' />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Region Change">
                                                                    <IconButton size='small' onClick={(event, rowData) => {
                                                                        this.regionChangeOps(row)
                                                                    }}>
                                                                        <TransferWithinAStationIcon fontSize='small' />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Promote Role">
                                                                    <IconButton size='small' onClick={(event, rowData) => {
                                                                        row.role_name = row.job_roles
                                                                        this.setState({
                                                                            selectedEmp: row,
                                                                        }, () => this.promotionOps(row))
                                                                    }}>
                                                                        <IntegrationInstructionsIcon fontSize='small' />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                {access.l4a && access.l4a.l4a_c ?
                                                                    <Tooltip title="Edit Employee">
                                                                        <IconButton size='small' onClick={(event, rowData) => {
                                                                            this.setState({
                                                                                postData: this.getNormalizedEditPostData(row),
                                                                                addUser: true,
                                                                                type: 'edit'
                                                                            })
                                                                        }
                                                                        }>
                                                                            <EditIcon fontSize='small' />
                                                                        </IconButton>
                                                                    </Tooltip> : null}
                                                                {access.l4a && access.l4a.l4a_c ?
                                                                    <Tooltip title="Assign End Date">
                                                                        <IconButton size='small' onClick={(event, rowData) => {
                                                                            this.openAssignEndDate(row)
                                                                        }}>
                                                                            <DateRangeIcon fontSize='small' />
                                                                        </IconButton>
                                                                    </Tooltip> : null}
                                                                {access.l4a && access.l4a.l4a_b ?
                                                                    <Tooltip title={this.props.link ? "Link External" : "Update External"}>
                                                                        <IconButton size='small' onClick={(event, rowData) => {
                                                                            this.getSubContractor()
                                                                            this.setState({
                                                                                postData: JSON.parse(JSON.stringify(row)),
                                                                                linkSubContractorDialog: true
                                                                            })
                                                                        }
                                                                        }>
                                                                            <LinkIcon fontSize='small' />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    : null}
                                                                <Tooltip title="Link Line Manager">
                                                                    <IconButton size='small' onClick={(event) => this.openLinkManagerDialog(event, row)}>
                                                                        <SupervisorAccountIcon fontSize='small' />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Leave Restriction">
                                                                    <IconButton size='small' onClick={(event) => this.openLeaveRestriction(row)}>
                                                                        <WorkOffIcon fontSize='small' />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title='Employee Past History'>
                                                                    <IconButton size='small' onClick={(event) => this.getEmployeeHistory(row)}>
                                                                        <WorkHistoryIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title='Link Business Unit'>
                                                                    <IconButton size='small' onClick={() => { this.openBusinessUnitDialog(row) }} >
                                                                        <AllInclusiveIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title='Delete Employee'>
                                                                    <IconButton size='small' onClick={() => { this.deleteEmployee(row) }} >
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                {
                                                                    BUCommentEnable(row.bu_key) &&
                                                                    <Tooltip title='Comment'>
                                                                        <IconButton size='small' onClick={() => { this.openCommentDialog(row) }} >
                                                                            <CommentIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }
                                                            </Box>
                                                        </TableCell>
                                                        {this.state.columns.filter((column) => column.field !== 'end_date').map((column) => (
                                                            <Tooltip
                                                                title={(() => {
                                                                    const tags = Array.isArray(row.tags) ? row.tags : []
                                                                    return (
                                                                        <Box display="flex" flexWrap="wrap" gridGap={4} maxWidth={260}>
                                                                            Tags: {tags.length > 0
                                                                                ? tags.map((tag, index) => {
                                                                                    const tagName = typeof tag === 'object' ? tag.name || tag.label || tag.tag : tag
                                                                                    return tagName ? <Chip key={tag.id || tagName || index} label={tagName} size="small" /> : null
                                                                                })
                                                                                : " - "}<br />
                                                                            {
                                                                                BUCommentEnable(row.bu_key) &&
                                                                                `Latest Comment: ${row.latest_comment ? row.latest_comment.comment : ' - '}`
                                                                            }
                                                                        </Box>
                                                                    )
                                                                })()}
                                                            >
                                                                <TableCell>
                                                                    {column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                                                </TableCell>
                                                            </Tooltip>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        component="div"
                                        rowsPerPageOptions={[10]}
                                        count={this.state.live.length}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        onPageChange={(e, newPage) => this.handleChangePage(e, newPage)}
                                        onRowsPerPageChange={(e) => this.handleChangeRowsPerPage(e)}
                                    />
                                </div>}
                        </TabPanel>

                        <TabPanel value={this.state.tabValue} index={1}>
                            {this.state.tableLoading ? <RotateCircleLoading color={getPrimaryColor()} /> :
                                <div>
                                    <TableContainer component={Paper}>
                                        <Toolbar  >
                                            <Box display={'flex'} flexDirection={'row'} width={'100%'}>
                                                <Box display="flex" flexDirection='row' flexGrow={1}>
                                                    <h2> Archive Employees</h2>
                                                </Box>
                                                <Box display="flex" flexDirection='row' alignItems='center' >
                                                    <Button
                                                        color='primary'
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => exportCsv(this.state.columns, this.state.archive)}
                                                        startIcon={<GetAppIcon fontSize='small' />}
                                                    >
                                                        Export
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Toolbar>
                                        <Table aria-label="simple table" size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align='center'>
                                                        Actions
                                                    </TableCell>
                                                    {this.state.columns.map((column) => (
                                                        <TableCell>
                                                            <TableSortLabel
                                                                active={this.state.orderBy === column.field}
                                                                direction={this.state.order === 'asc' ? 'asc' : 'desc'}
                                                                onClick={(e) => this.handleSort(column.field, this.state.tabValue)}>
                                                                {column.title}
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    {this.state.columns.map((column) => (
                                                        <TableCell >{this.getFilters(column, 'archive')}</TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(this.state.rowsPerPage > 0 ? this.state.archive.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage) : this.state.archive).map((row) => (
                                                    <TableRow key={row.name}>
                                                        <TableCell>
                                                            <Box display='flex' justifyContent={'center'} alignItems={'center'}>
                                                                <Tooltip title="Change History">
                                                                    <IconButton size="small" onClick={(event, rowData) => {
                                                                        this.setState({
                                                                            selectedEmp: row
                                                                        }, () => { this.getRegionChangeInfo(row); this.getPromotionHistory(row) })
                                                                    }}>
                                                                        <HistoryIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Region Change">
                                                                    <IconButton size="small" onClick={(event, rowData) => {
                                                                        this.regionChangeOps(row)
                                                                    }}>
                                                                        <TransferWithinAStationIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Promote Role">
                                                                    <IconButton size="small" onClick={(event, rowData) => {
                                                                        row.role_name = row.job_roles
                                                                        this.setState({
                                                                            selectedEmp: row,
                                                                        }, () => this.promotionOps(row))
                                                                    }}>
                                                                        <IntegrationInstructionsIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                {access.l4a && access.l4a.l4a_c ?
                                                                    <Tooltip title="Edit Employee">
                                                                        <IconButton size="small" onClick={(event, rowData) => {
                                                                            this.setState({
                                                                                postData: this.getNormalizedEditPostData(row),
                                                                                addUser: true,
                                                                                type: 'edit'
                                                                            })
                                                                        }
                                                                        }>
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip> : null}
                                                                {access.l4a && access.l4a.l4a_c ?
                                                                    <Tooltip title="Assign End Date">
                                                                        <IconButton size="small" onClick={(event, rowData) => {
                                                                            this.openAssignEndDate(row)
                                                                        }
                                                                        }>
                                                                            <DateRangeIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip> : null}
                                                                <Tooltip title="Unarchive Employee">
                                                                    <IconButton size='small' onClick={(event) => this.setState({
                                                                        unarchiveEmployeeDialog: true,
                                                                        selectedUser: row
                                                                    })}>
                                                                        <LinkOffIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title='Employee Past History'>
                                                                    <IconButton size='small' onClick={(event) => this.setState({
                                                                        employeeHistoryDialog: true,
                                                                        selectedUser: row
                                                                    })}>
                                                                        <WorkHistoryIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title='Link Business Unit'>
                                                                    <IconButton size='small' onClick={() => { this.openBusinessUnitDialog(row) }} >
                                                                        <AllInclusiveIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title='Comment'>
                                                                    <IconButton size='small' onClick={() => { this.openCommentDialog(row) }} >
                                                                        <CommentIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Box>
                                                        </TableCell>
                                                        {this.state.columns.map((column) => (
                                                            <Tooltip title={(() => {
                                                                const tags = Array.isArray(row.tags) ? row.tags : []
                                                                return (
                                                                    <Box display="flex" flexWrap="wrap" gridGap={4} maxWidth={260}>
                                                                        Tags: {tags.length > 0
                                                                            ? tags.map((tag, index) => {
                                                                                const tagName = typeof tag === 'object' ? tag.name || tag.label || tag.tag : tag
                                                                                return tagName ? <Chip key={tag.id || tagName || index} label={tagName} size="small" /> : null
                                                                            })
                                                                            : " - "}<br />
                                                                        Latest Comment: {row.latest_comment ? row.latest_comment.comment : ' - '}
                                                                    </Box>
                                                                )
                                                            })()}>
                                                                <TableCell>
                                                                    {column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                                                </TableCell>
                                                            </Tooltip>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        component="div"
                                        rowsPerPageOptions={[10]}
                                        count={this.state.archive.length}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        onPageChange={(e, newPage) => this.handleChangePage(e, newPage)}
                                        onRowsPerPageChange={(e) => this.handleChangeRowsPerPage(e)}
                                    />
                                </div>}
                        </TabPanel>

                    </Paper>

                    <Dropzone
                        open={this.state.dropZoneModal}
                        onClose={this.dropzoneClose}
                        onChange={(e) => this.fileToRead(e)}
                        preview={this.reviewModalOpen}
                    />

                    <Dialog
                        fullWidth={true}
                        maxWidth="sm"
                        open={this.state.exportFilterDialogOpen}
                        onClose={() => this.setState({ exportFilterDialogOpen: false })}
                    >
                        <DialogTitle>Export Filters</DialogTitle>
                        <DialogContent>
                            <Typography variant='body2' style={{ marginBottom: '10px' }}>
                                Select filters to include as query parameters in Excel export.
                            </Typography>
                            {[
                                { key: 'job_roles', label: 'Job Title' },
                                { key: 'owner_region', label: 'Sub Division' },
                                { key: 'owner_delivery_unit', label: 'Operations Lead' },
                                { key: 'sector', label: 'Sector' },
                                { key: 'market_subvertical', label: 'Division' },
                                { key: 'role_group_id', label: 'Role Group' },
                                { key: 'payrole_process', label: 'Payroll Process' },
                            ].map((filterItem) => (
                                <Box key={filterItem.key} display='flex' alignItems='center'>
                                    <Checkbox
                                        size='small'
                                        checked={Boolean(this.state.exportFilterSelection[filterItem.key])}
                                        onChange={() => this.handleExportFilterToggle(filterItem.key)}
                                        color='primary'
                                    />
                                    <Typography variant='body2'>{filterItem.label}</Typography>
                                </Box>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color='secondary'
                                onClick={() => this.setState({ exportFilterDialogOpen: false })}
                            >
                                Cancel
                            </Button>
                            <Button
                                color='primary'
                                disabled={this.state.excelExportDisabled}
                                onClick={this.handleExportFilterSubmit}
                            >
                                Export Excel
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Modal
                        open={this.state.reviewModal}
                        close={this.reviewModalClose}
                        onUpload={this.bulkUpload}
                        columns={[
                            { title: 'Employee No', field: 'emp_no' },
                            {
                                title: 'First Name',
                                field: 'first_name',
                                customFilterAndSearch: (term, rowData) => customFilter(term, rowData, 'first_name'),
                            },
                            {
                                title: 'Last Name',
                                field: 'last_name',
                                customFilterAndSearch: (term, rowData) => customFilter(term, rowData, 'last_name'),
                            },
                            {
                                title: 'Job Title',
                                field: 'job_title',
                                lookup: this.state.lookupData?.job_titlesID,
                            },
                            // { title: 'Job Title', field: 'job_title', lookup: this.state.job_titles, validate: rowData => rowData.job_title !== '' },
                            { title: 'Email Address', field: 'email' },
                            { title: 'Sub Divison', field: 'owner_region', editable: 'onAdd', lookup: this.state.lookupData?.owner_region_sector_lookup },
                            { title: 'Operations Lead', field: 'owner_delivery_unit', lookup: this.state.lookupData?.owner_delivery_lookup },
                            { title: 'Sector', field: 'sector', lookup: this.state.lookupData?.subsector_lookup },
                            { title: 'Market Subvertical', field: 'market_subvertical', lookup: this.state.lookupData?.market_subvertical_lookup },
                            { title: 'Availability', field: 'availability' },
                            { title: 'Pay Role Process', field: 'payrole_process', lookup: this.state.lookupData?.payrole_process_lookup },
                            { title: 'Start Date', field: 'start_date', type: 'date', },
                            { title: 'End Date', field: 'end_date', type: 'date', },
                        ]}
                        data={this.state.dataToUpload}
                        loading={this.state.bulkUploadLoader}
                        title={"Employee excel data review"}
                    />

                    <Dialog
                        open={this.state.promotionDialog}
                        onClose={this.promotionDialogClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth={'md'}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            <Box display={'flex'} justifyContent={'space-around'} alignItems="center">
                                <Box>
                                    Promote - {this.state.selectedEmp?.first_name + ' ' + this.state.selectedEmp?.last_name + ' (Emp. No - ' + this.state.selectedEmp?.emp_no + ')'}
                                </Box>
                                <Box marginLeft={1}>
                                    <Export selectedEmp={this.state.selectedEmp} allData={false} />
                                </Box>
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <Box style={{ margin: 10 }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <AutcompleteInput
                                            id="role"
                                            label="Role"
                                            options={this.state.lookupData?.job_title?.filter((role) => role.id !== this.state.selectedEmp?.job_title)}
                                            onChange={(e, val) => {
                                                if (val) {
                                                    this.setState({ selectedRole: val }, () => {
                                                        this.setState({ nextDisabled: false })
                                                    })
                                                } else {
                                                    this.setState({ selectedRole: null }, () => {
                                                        this.setState({ nextDisabled: true })
                                                    })
                                                }
                                            }}
                                            optionLabel={option => option.name}
                                            value={this.state.selectedRole}
                                            variant={'standard'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <KeyboardDatePicker
                                                autoOk
                                                // clearable
                                                animateYearScrolling
                                                variant="inline"
                                                format="dd/MM/yyyy"
                                                margin="normal"
                                                id="promotionDate"
                                                label="Promotion Date"
                                                maxDate={moment().add(3, 'months')}
                                                value={this.state.promotionDate}
                                                onChange={(date) => this.setState({ promotionDate: date })}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                style={{ margin: 0 }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>

                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button color='secondary' onClick={this.promotionDialogClose} >
                                Cancel
                            </Button>
                            <Button color='primary' onClick={() => this.setState({ promotionHistoryDialog: true })} >
                                History
                            </Button>
                            <Button color="primary" disabled={this.state.nextDisabled} onClick={() => {
                                this.getUnassignedSchedules()
                            }}>
                                Next
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={this.state.regionChangeDialog}
                        onClose={this.regionChangeDialogClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth={'md'}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            Region Change - {this.state.selectedEmp.first_name + ' ' + this.state.selectedEmp.last_name + ' (Emp. No - ' + this.state.selectedEmp.emp_no + ')'}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6} md={6}>
                                    <AutcompleteInput
                                        id="region"
                                        label="Region"
                                        options={this.state.lookupData?.owner_region_sector?.filter((region) => region.id !== this.state.selectedEmp?.owner_region)}
                                        onChange={(e, v) => this.setState({ selectedRegion: v })}
                                        optionLabel={option => option.name}
                                        value={this.state.selectedRegion}
                                        variant={'standard'}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                        <KeyboardDatePicker
                                            autoOk
                                            clearable
                                            animateYearScrolling
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="region_change__date"
                                            label="Region Change Date"
                                            // maxDate={moment()}
                                            value={this.state.regionChangeDate}
                                            onChange={(date) => this.setState({ regionChangeDate: date })}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ margin: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.regionChangeDialogClose} color="secondary">
                                Cancel
                            </Button>
                            <Button onClick={() => { this.submitRegionChange() }} color="primary">
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={this.state.regionHistoryDialog}
                        onClose={this.regionHistoryDialogClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth={'md'}
                        fullWidth={true}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            {this.state.selectedEmp?.first_name + ' ' + this.state.selectedEmp?.last_name + ' (Emp. No - ' + this.state.selectedEmp?.emp_no + ')'}
                        </DialogTitle>
                        <DialogContent>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography >{'Region Change History'}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>

                                    <MaterialTable

                                        columns={[
                                            { title: 'Region Change Date', field: 'changed_on', type: 'date' },
                                            // { title: 'From Region', field: 'old_owner_region', lookup: this.state.owner_region, },
                                            { title: 'To Region', field: 'new_owner_region', lookup: this.state.lookupData?.owner_region_sector_lookup, },
                                        ]}
                                        style={{ width: '100%' }}
                                        data={this.state.regionHistory}
                                        options={{
                                            toolbar: false,
                                            paging: false,
                                            headerStyle: {
                                                fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography >{'Promotion History'}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>

                                    <MaterialTable

                                        columns={[
                                            { title: 'Role', field: 'migration_taken.previousRole.role', lookup: this.state.job_titlesID },
                                            // { title: 'From Region', field: 'old_owner_region', lookup: this.state.owner_region, },
                                            { title: 'PromotionDate', render: (rowData) => <div>{rowData.migration_taken.promotionDate.slice(0, 10)}</div> },
                                            { title: 'Promotion Description', field: 'migration_taken.Description' },
                                            { title: 'Schedules ', render: (rowData) => <Button color='primary' onClick={() => this.setState({ projectsArray: rowData.migration_taken?.previousRole?.schdl_data }, this.setState({ promotionHistorySchedules: true }))} >Show Schedules</Button> },
                                        ]}
                                        style={{ width: '100%' }}
                                        data={this.state.promotionHistory}
                                        options={{
                                            toolbar: false,
                                            paging: false,
                                            headerStyle: {
                                                fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.regionHistoryDialogClose} color="secondary">
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.verifyPromotionChanges} onClose={() => this.setState({ verifyPromotionChanges: false })} >
                        <DialogTitle><Typography variant='h5' >Verify Promotion Changes</Typography></DialogTitle>
                        <DialogContent>
                            <Grid container>
                                {this.state.verifySchedules.map((project, projectIndex) => (
                                    <React.Fragment key={projectIndex}>
                                        {
                                            project.curentCRMSchedules?.length > 0 ?
                                                <>
                                                    < h2 > {project.crm}</h2>
                                                    <Grid xs={12} item >
                                                        <h3>Promoted Role schedules</h3>
                                                        {project.newCRMSchedules?.length > 0 ?
                                                            <SchedulesContainer schedules={project.newCRMSchedules} /> : <h4 >No schedules</h4>
                                                        }     </Grid>
                                                    <Grid xs={12} item >
                                                        <h3>Previous Role schedules</h3>
                                                        {project.oldCRMSchedules?.length > 0 ? < SchedulesContainer schedules={project.oldCRMSchedules} /> : <h4>No schedules</h4>}
                                                    </Grid>
                                                    <Grid xs={12} item >
                                                        <h3>Current Role schedules</h3>
                                                        <SchedulesContainer schedules={project.curentCRMSchedules} />
                                                    </Grid>
                                                </>

                                                : null}

                                    </React.Fragment>
                                ))
                                }
                            </Grid>
                        </DialogContent >
                        <DialogActions>
                            <Button onClick={() => this.setState({ verifyPromotionChanges: false })} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={() => this.submitPromotion(this.state)}>
                                {/* <Button onClick={this.submitPromotion}> */}
                                Promote
                            </Button>
                        </DialogActions>
                    </Dialog >

                    <Dialog open={this.state.promotionHistorySchedules} onClose={() => this.setState({ promotionHistorySchedules: false })}>
                        <DialogTitle><Typography variant='h5' >Schedules</Typography></DialogTitle>
                        <DialogContent>
                            {
                                this.state.projectsArray?.map((project, projectIndex) =>
                                    <React.Fragment key={projectIndex}>
                                        {project.shdl_data.length > 0 ? <HistorySchedulesContainer crm_name={project.crm_name} schedules={project.shdl_data} /> : null}
                                    </React.Fragment>
                                )
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.setState({ promotionHistorySchedules: false })} color="secondary">
                                Cancel
                            </Button>

                        </DialogActions>
                    </Dialog>

                    <Dialog fullWidth={true} maxWidth={'xs'} open={this.state.addUser} onClose={addDialogClose}>
                        <DialogTitle>
                            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} width='100%'>
                                <Typography variant='h5' >{this.state.type === "add" ? "Add " : "Edit "} Employee</Typography>
                                {this.state.type === 'add' ?
                                    <Button variant='contained' color='primary' onClick={() => this.importFromAtr()}>
                                        Import from ATR
                                    </Button> : null}
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                                <TextField
                                    style={{ marginBottom: '7px' }}
                                    id="emp_no"
                                    label="Employee Number"
                                    value={this.state.postData.emp_no}
                                    onChange={e => this.handleTextChange(e)}
                                    variant="outlined"
                                    InputLabelProps={this.getInputLabelProps(this.state.postData.emp_no)}
                                    fullWidth
                                />
                                <TextField
                                    style={{ marginBottom: '7px' }}
                                    id="first_name"
                                    label="First Name"
                                    value={this.state.postData.first_name}
                                    type="name"
                                    variant="outlined"
                                    onChange={e => this.handleTextChange(e)}
                                    InputLabelProps={this.getInputLabelProps(this.state.postData.first_name)}
                                    fullWidth
                                />
                                <TextField
                                    style={{ marginBottom: '7px' }}
                                    id="last_name"
                                    label="Last Name"
                                    value={this.state.postData.last_name}
                                    type="name"
                                    variant="outlined"
                                    onChange={e => this.handleTextChange(e)}
                                    InputLabelProps={this.getInputLabelProps(this.state.postData.last_name)}
                                    fullWidth
                                />
                                {this.state.type === "edit" ?
                                    <TextField
                                        style={{ marginBottom: '7px' }}
                                        type='number'
                                        id="availability"
                                        label="Availability"
                                        value={this.state.postData.availability}
                                        variant="outlined"
                                        onChange={e => this.handleTextChange(e)}
                                        InputLabelProps={this.getInputLabelProps(this.state.postData.availability)}
                                        fullWidth
                                    /> : null}
                                <Autocomplete
                                    style={{ marginBottom: '7px' }}
                                    id="payrole_process"
                                    value={this.state.postData.payrole_process_id || this.state.postData.payrole_process ? { id: this.state.postData.payrole_process_id || this.state.postData.payrole_process, name: this.state.postData.payrole_process_name } : null}
                                    options={this.state.lookupData?.payrole_process}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && String(option.id) === String(value.id)}
                                    onChange={(e, val) => this.handleSelectChange("payrole_process_id", 'payrole_process_name', val)}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Payrole Process" InputLabelProps={this.getInputLabelProps(this.state.postData.payrole_process_id || this.state.postData.payrole_process, params.InputLabelProps)} />}
                                />
                                <Autocomplete
                                    style={{ marginBottom: '7px' }}
                                    id="job_title"
                                    value={this.state.postData.job_title || this.state.postData.job_roles
                                        ? { id: this.state.postData.job_title, name: this.state.postData.job_roles }
                                        : null}
                                    options={this.state.lookupData?.job_title}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && String(option.id) === String(value.id)}
                                    onChange={(e, val) => this.handleSelectChange("job_title", 'job_roles', val)}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Job Title" InputLabelProps={this.getInputLabelProps(this.state.postData.job_title || this.state.postData.job_roles, params.InputLabelProps)} />}
                                />
                                {this.state.postData.r12_job_title_name ? (
                                    <Typography variant="body2" style={{ marginBottom: '7px', color: '#000', fontSize: '0.9rem' }}>
                                        R12 Job: {this.state.postData.r12_job_title_name}
                                    </Typography>
                                ) : null}
                                <Autocomplete
                                    style={{ marginBottom: '7px' }}
                                    id="role_group"
                                    value={(this.state.lookupData?.role_group || []).find((option) => String(option.id) === String(this.state.postData.role_group_id)) || null}
                                    options={this.state.lookupData?.role_group || []}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && String(option.id) === String(value.id)}
                                    onChange={(e, val) => this.handleSelectChange('role_group_id', 'role_group_name', val)}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Role Group" InputLabelProps={this.getInputLabelProps(this.state.postData.role_group_id, params.InputLabelProps)} />}
                                />

                                <TextField
                                    style={{ marginBottom: '7px' }}
                                    id="email"
                                    label="Email"
                                    value={this.state.postData.email}
                                    type="name"
                                    variant="outlined"
                                    onChange={e => this.handleTextChange(e)}
                                    InputLabelProps={this.getInputLabelProps(this.state.postData.email)}
                                    fullWidth
                                />
                                <Autocomplete
                                    style={{ marginBottom: '7px' }}
                                    id="owner_region"
                                    value={this.state.postData.owner_region_id || this.state.postData.owner_region
                                        ? {
                                            id: this.state.postData.owner_region_id || this.state.postData.owner_region,
                                            name: this.state.postData.owner_region_name
                                        }
                                        : null}
                                    options={this.state.lookupData?.owner_region_sector}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && String(option.id) === String(value.id)}
                                    onChange={(e, val) => this.handleSelectChange("owner_region_id", 'owner_region_name', val)}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Sub Division" InputLabelProps={this.getInputLabelProps(this.state.postData.owner_region_id || this.state.postData.owner_region, params.InputLabelProps)} />}
                                />
                                <Autocomplete
                                    style={{ marginBottom: '7px' }}
                                    id="owner_delivery_unit"
                                    value={(() => {
                                        const options = this.state.lookupData?.owner_delivery || []
                                        const matchedOption = options.find((item) =>
                                            String(item.id) === String(this.state.postData.owner_delivery_id || this.state.postData.owner_delivery_unit)
                                            || String(item.name).toLowerCase() === String(this.state.postData.owner_delivery_name || this.state.postData.owner_delivery_unit || '').toLowerCase()
                                        )
                                        if (matchedOption) return matchedOption

                                        const fallbackId = this.state.postData.owner_delivery_id || this.state.postData.owner_delivery_unit
                                        const fallbackName = this.state.postData.owner_delivery_name || this.state.postData.owner_delivery_unit
                                        return fallbackId || fallbackName
                                            ? { id: fallbackId || fallbackName, name: fallbackName || String(fallbackId) }
                                            : null
                                    })()}
                                    options={this.state.lookupData?.owner_delivery}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && String(option.id) === String(value.id)}
                                    onChange={(e, val) => this.handleSelectChange("owner_delivery_id", 'owner_delivery_name', val)}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Operations Lead" InputLabelProps={this.getInputLabelProps(this.state.postData.owner_delivery_id || this.state.postData.owner_delivery_unit || this.state.postData.owner_delivery_name, params.InputLabelProps)} />}
                                />
                                <Autocomplete
                                    style={{ marginBottom: '7px' }}
                                    id="sector"
                                    value={(() => {
                                        const options = this.state.lookupData?.subsector || []
                                        const matchedOption = options.find((item) =>
                                            String(item.id) === String(this.state.postData.sector_id || this.state.postData.sector)
                                            || String(item.name).toLowerCase() === String(this.state.postData.sector_name || this.state.postData.sector || '').toLowerCase()
                                        )
                                        if (matchedOption) return matchedOption

                                        const fallbackId = this.state.postData.sector_id || this.state.postData.sector
                                        const fallbackName = this.state.postData.sector_name || this.state.postData.sector
                                        return fallbackId || fallbackName
                                            ? { id: fallbackId || fallbackName, name: fallbackName || String(fallbackId) }
                                            : null
                                    })()}
                                    options={this.state.lookupData?.subsector}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && String(option.id) === String(value.id)}
                                    onChange={(e, val) => this.handleSelectChange("sector_id", 'sector_name', val)}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Sector" InputLabelProps={this.getInputLabelProps(this.state.postData.sector_id || this.state.postData.sector || this.state.postData.sector_name, params.InputLabelProps)} />}
                                />
                                <Autocomplete
                                    style={{ marginBottom: '7px' }}
                                    id="market_subvertical"
                                    value={this.state.postData.market_subvertical ? { id: this.state.postData.market_subvertical, name: this.state.postData.market_subvertical_name } : null}
                                    options={this.state.lookupData?.market_subvertical || this.state.lookupData?.marketsubvertical || []}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && String(option.id) === String(value.id)}
                                    onChange={(e, val) => this.handleSelectChange("market_subvertical", 'market_subvertical_name', val)}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Divison" InputLabelProps={this.getInputLabelProps(this.state.postData.market_subvertical || this.state.postData.market_subvertical_name, params.InputLabelProps)} />}
                                />
                                {this.state.isAtr ?
                                    <Autocomplete
                                        style={{ marginBottom: '7px' }}
                                        id="crm"
                                        value={this.state.postData.crm ? { id: this.state.postData.crm, name: this.state.postData.crm_name } : null}
                                        options={this.state.crmData || []}
                                        getOptionLabel={(option) => option.name}
                                        isOptionEqualToValue={(option, value) => value && String(option.id) === String(value.id)}
                                        onChange={(e, val) => this.handleSelectChange("crm", 'crm_name', val)}
                                        fullWidth
                                        renderInput={(params) => <TextField variant="outlined" {...params} label="CRM" InputLabelProps={this.getInputLabelProps(this.state.postData.crm, params.InputLabelProps)} />}
                                    /> : null}
                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker
                                        autoOk
                                        clearable
                                        animateYearScrolling
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="start_date"
                                        label="Start Date"
                                        value={this.state.postData.start_date}
                                        InputLabelProps={this.getInputLabelProps(this.state.postData.start_date)}
                                        onChange={(date) => {
                                            let postData = this.state.postData
                                            postData['start_date'] = date
                                            this.setState({ postData })
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ margin: 0 }}
                                    />
                                </MuiPickersUtilsProvider>
                                <Box marginTop={1}>
                                    <TextField
                                        style={{ marginBottom: '7px' }}
                                        id="power_history"
                                        label="Power History"
                                        value={this.state.postData.power_history}
                                        disabled={this.state.type === 'edit' && this.state.postData?.power_history_id?.length === 0}
                                        type="text"
                                        variant="outlined"
                                        helperText='Enter number of years based on previous PT&D till date.'
                                        FormHelperTextProps={{
                                            style: { fontSize: '12px', color: '#000000' }
                                        }}
                                        onChange={e => this.handleTextChange(e)}
                                        InputLabelProps={this.getInputLabelProps(this.state.postData.power_history)}
                                        fullWidth
                                    />
                                </Box>
                                <TextField
                                    style={{ marginBottom: '7px' }}
                                    id="bb_history"
                                    label="BB History"
                                    value={this.state.postData.bb_history}
                                    disabled={this.state.type === 'edit' && this.state.postData?.bb_history_id?.length === 0}
                                    type="text"
                                    variant="outlined"
                                    helperText='Enter number of years based on previous PT&D before start date of employee.'
                                    FormHelperTextProps={{
                                        style: { fontSize: '12px', color: '#000000' }
                                    }}
                                    onChange={e => this.handleTextChange(e)}
                                    InputLabelProps={this.getInputLabelProps(this.state.postData.bb_history)}
                                    fullWidth
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={addDialogClose} color="primary">
                                Cancel
                            </Button>
                            {this.state.type === 'add' ?
                                <Button disabled={this.state.addDisabled} onClick={() => this.postOps(this.state.postData)} color="primary">
                                    Add
                                </Button> :
                                <Button disabled={this.state.addDisabled} onClick={() => this.putOps(this.state.postData)} color="primary">
                                    Edit
                                </Button>}
                        </DialogActions>
                    </Dialog>

                    <Dialog maxWidth="xs" open={this.state.endDateDialog} handleClose={() => this.setState({ endDateDialog: false })}>
                        <DialogTitle>Assign End Date</DialogTitle>
                        <Alert severity="warning">Changing the end date will lead to changes in the schedules for the employee</Alert>
                        <DialogContent>
                            <Box padding={1} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        autoOk
                                        clearable
                                        animateYearScrolling
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="end_date"
                                        label="End Date"
                                        value={this.state.postData.end_date}
                                        minDate={moment(this.state.postData.start_date) > moment().subtract(6, 'months') ? moment(this.state.postData.start_date) : moment().subtract(6, 'months')}
                                        onChange={(date) => {
                                            let postData = this.state.postData
                                            postData['end_date'] = date
                                            this.setState({ postData })
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        variant='outlined'
                                    />

                                    {
                                        this.state.postData && BUArchiveReasonEnable(this.state.postData.bu_key) && (
                                            this.state.archiveReasonLoading ?
                                                <CircularProgress size={24} />
                                                :
                                                <Autocomplete
                                                    style={{ marginTop: 10, width: 220 }}
                                                    options={this.state.archiveReasons || []}
                                                    getOptionLabel={(option) => option.name}
                                                    value={this.state.selectedArchiveReason}
                                                    onChange={(event, newValue) => {
                                                        this.setState({ selectedArchiveReason: newValue })
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Archive Reason" margin="normal" variant='outlined' />}
                                                />
                                        )}

                                </MuiPickersUtilsProvider>
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' size='small' onClick={() => this.setState({ endDateDialog: false })} color="secondary">
                                Cancel
                            </Button>
                            <Button variant='contained' size='small' disabled={this.state.endDateSubmitDisabled || this.state.archiveReasonLoading} onClick={() => { this.openArchiveConfirmation() }} color="primary">
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.confirmationDialog} handleClose={() => this.setState({ confirmationDialog: false })}>
                        <DialogTitle>Confirmation</DialogTitle>
                        <DialogContent>
                            You are setting a End Date to {this.state.postData.first_name} {this.state.postData.last_name}. Are you sure?
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' size='small' onClick={() => this.setState({ confirmationDialog: false })} color="secondary">
                                No
                            </Button>
                            <Button variant='contained' size='small' disabled={this.state.confirmationButtonDisabled} onClick={() => { this.assignEndDate(this.state.postData) }} color="primary">
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={this.state.deleteEmployeeDialog}
                        onClose={this.deleteEmployeeDialogClose}
                        fullWidth={true}
                        maxWidth="xs"
                    >
                        <DialogTitle>
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <Typography variant="h6" style={{ fontWeight: 600 }}>
                                    Warning
                                </Typography>
                                <CloseIcon
                                    onClick={this.deleteEmployeeDialogClose}
                                    color="error"
                                    style={{ cursor: 'pointer' }}
                                />
                            </Box>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Alert severity="warning" style={{ marginBottom: '12px' }}>
                                Please review before deleting this employee.
                            </Alert>
                            <DialogContentText style={{ color: '#333', lineHeight: 1.6 }}>
                                This is an non reversibile action please make sure not to delete an actual employee. If you are trying to delete an employee who left BB, you should assign an end date so that the employee moves to the archive section.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.deleteEmployeeDialogClose} color="secondary" variant="outlined" size="small">
                                Cancel
                            </Button>
                            <Button onClick={this.deleteEmployeeDialogOk} color="primary" variant="contained" size="small" autoFocus>
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.promotionHistoryDialog} onClose={() => this.setState({ promotionHistoryDialog: false })}>
                        <DialogContent>
                            <PromotionHistory emp={this.state.selectedEmp} closeDialog={this.closeDialog} />
                        </DialogContent>
                    </Dialog>

                    <Dialog maxWidth="xl" open={this.state.promotionGraphDialog} onClose={() => this.setState({ promotionGraphDialog: false })}>
                        <DialogTitle>{this.state.selectedEmp ? (this.state.selectedEmp.last_name + ", " + this.state.selectedEmp.first_name + "'s Projects") : null}</DialogTitle>
                        <DialogContent style={{ width: "1200px" }}>
                            <Box>
                                <PromotionUnassignedSchedules
                                    unassignedSchedules={this.state.unassignedSchedules}
                                    promotionDate={this.state.promotionDate}
                                    selectedEmp={this.state.selectedEmp}
                                    selectedRole={this.state.selectedRole}
                                    closeDialog={this.closePromotionDialog}
                                />
                            </Box>
                        </DialogContent>
                    </Dialog>

                    <Dialog maxWidth="sm" open={this.state.promoteRoleLoading} aria-labelledby="form-dialog-title">
                        <DialogContent>
                            <Box m={5} p={2}>
                                <CoffeeLoading />
                            </Box>
                        </DialogContent>
                    </Dialog>

                    <Dialog maxWidth="lg" open={this.state.linkSubContractorDialog} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">
                            <Box display='flex' justifyContent='space-between' alignItems='center' >
                                <Typography variant="h6">{this.props.link ? "Link External for " : "Update External for " + this.state.postData.first_name + " " + this.state.postData.last_name}</Typography>
                                <CloseIcon onClick={() => this.setState({ linkSubContractorDialog: false })} style={{ float: 'right', color: 'red' }} />
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <Autocomplete
                                style={{ width: '350px' }}
                                id="subcontractor"
                                value={this.state.selectedSubcontractor}
                                options={this.state.subcontractorList}
                                getOptionLabel={(option) => option.name}
                                isOptionEqualToValue={(option, value) => value && option.id === value}
                                onChange={(e, val) => { this.setState({ selectedSubcontractor: val }) }}
                                fullWidth
                                renderInput={(params) => <TextField variant="outlined" {...params} label="Select External" />}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' size="small" disabled={this.state.linkDisabled} color='primary' onClick={() => {
                                if (this.props.link) {
                                    this.linkSubContractor()
                                } else {
                                    this.updateSubContractor()
                                }
                            }} >
                                {this.props.link ? 'Link' : 'Update'}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog fullWidth={true} maxWidth="sm" open={this.state.linkLineManagerDialog} onClose={() => this.setState({ linkLineManagerDialog: false })}>
                        <DialogTitle>
                            <Box display='flex' flexDirection={'row'} alignItems='center' >
                                <Box flexGrow={1}>
                                    <Typography variant="h6">{this.state.postData?.first_name + ' ' + this.state.postData?.last_name}</Typography>
                                </Box>
                                <CloseIcon onClick={() => this.setState({ linkLineManagerDialog: false })} color='error' style={{ cursor: 'pointer' }} />
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <LineManagerTabs
                                userData={this.state.postData}
                                employeeData={this.state.linkEmployeeData}
                                selectedLineManager={this.state.selectedLineManager}
                                reloadEmployeeData={this.reloadEmployeeData}
                            />
                        </DialogContent>
                    </Dialog>

                    <Dialog fullWidth={true} maxWidth="md" open={this.state.leaveRestrictionDialog} >
                        <DialogTitle>
                            <Box display='flex' flexDirection={'row'} alignItems='center' >
                                <Box flexGrow={1}>
                                    <Typography variant="h6">{this.state.selectedUser?.first_name + ' ' + this.state.selectedUser?.last_name + "'s Leaves"}</Typography>
                                </Box>
                                <CloseIcon onClick={() => this.handleLeaveRestrictionClose()} color='error' style={{ cursor: 'pointer' }} />
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <LeaveRestrictionTabs employeeData={this.state.selectedUser} />
                        </DialogContent>
                    </Dialog>

                    <Dialog fullWidth={true} maxWidth="lg" open={this.state.r12Dialog} >
                        <DialogTitle>
                            <Box display='flex' flexDirection={'row'} alignItems='center' >
                                <Box flexGrow={1}>
                                    <Typography variant="h6">R12 Employee Data</Typography>
                                </Box>
                                <CloseIcon onClick={() => this.setState({ r12Dialog: false })} color='error' style={{ cursor: 'pointer' }} />
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <MaterialTable
                                title=""
                                columns={[
                                    { title: 'Employee No', field: 'employee_number' },
                                    { title: 'First Name', field: 'first_name' },
                                    { title: 'Last Name', field: 'surname' },
                                    { title: 'Job Title', field: 'job_title' },
                                    { title: 'Email', field: 'email_address' },
                                    { title: 'Sub Division', field: 'owner_region_name' },
                                    { title: 'Sector', field: 'subsector_name' },
                                    { title: 'Division', field: 'marketsubvertical_name' },
                                    {
                                        title: 'Start Date', field: 'latest_start_date',
                                        customFilterAndSearch: (term, rowData) => moment(rowData.latest_start_date).format('DD-MM-YYYY').includes(term),
                                        render: (rowData) => rowData.latest_start_date ? moment(rowData.latest_start_date).format('DD-MM-YYYY') : null
                                    },
                                ]}
                                data={this.state.r12Data}
                                isLoading={this.state.r12Loading}
                                options={{
                                    paging: false,
                                    search: true,
                                    filtering: true,
                                    toolbar: false,
                                }}
                                onRowClick={(event, rowData) => this.addSelectedUser(rowData)}
                            />
                        </DialogContent>
                    </Dialog>

                    <Dialog fullWidth={true} maxWidth="xs" open={this.state.unarchiveEmployeeDialog} >
                        <DialogTitle>
                            Confirmation
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to unarchive the following {this.state.selectedUser ? (this.state.selectedUser.first_name + "  " + this.state.selectedUser.last_name) : null}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.setState({ unarchiveEmployeeDialog: false })} color="secondary">
                                Cancel
                            </Button>
                            <Button onClick={() => this.unarchiveEmployee()} color="primary">
                                Unarchive
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog fullWidth={true} maxWidth="md" open={this.state.employeeHistoryDialog} onClose={() => this.setState({ employeeHistoryDialog: false })}>
                        <DialogTitle>
                            <Box display='flex' flexDirection={'space-between'} alignItems='center' >
                                <Box flexGrow={1}>
                                    <Typography variant="h6">{this.state.selectedUser?.first_name + ' ' + this.state.selectedUser?.last_name + `'s History`}</Typography>
                                </Box>
                                <Box>
                                    <Tooltip title="Add Experience" arrow>
                                        <IconButton onClick={() => this.setState({ addExperienceDialog: true, isEdit: false, typeOfExperience: null, yearsOfExperience: 0, selectedHistoryRole: null, selectedHistoryClient: null, selectedHistoryDescipline: null })} color='primary' size='small'>
                                            <AddIcon fontSize='small' />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Close" arrow>
                                        <IconButton onClick={() => this.setState({ employeeHistoryDialog: false })} size='small'>
                                            <CloseIcon fontSize='small' color='error' />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            {!this.state.employeeHistoryLoading ?
                                <TableContainer component={Paper}>
                                    <Table size='small' sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Type of Experience</TableCell>
                                                <TableCell>Role</TableCell>
                                                <TableCell>Client</TableCell>
                                                <TableCell>Discipline</TableCell>
                                                <TableCell>Past Years of Experience</TableCell>
                                                <TableCell>RMS Years of Experience</TableCell>
                                                <TableCell>Years of Experience</TableCell>
                                                <TableCell />
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.employeeHistoryData.length === 0 ?
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center">No Data to display</TableCell>
                                                </TableRow> :
                                                this.state.employeeHistoryData.map((history, index) => (
                                                    <TableRow
                                                        key={index}>
                                                        <TableCell>{type_of_experience[history.type]}</TableCell>
                                                        <TableCell>{history.role}</TableCell>
                                                        <TableCell>{history.client}</TableCell>
                                                        <TableCell>{history.descipline}</TableCell>
                                                        <TableCell>{history.years_of_experience}</TableCell>
                                                        <TableCell>{history.cumulative_year_of_experience}</TableCell>
                                                        <TableCell>{history.total_years_of_experience}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Edit Years of Experience" arrow>
                                                                <IconButton onClick={() => this.editExperience(index, history)} color='primary' size='small'><EditIcon /></IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer> : <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width='100%' ><CircularProgress /></Box>}
                        </DialogContent>
                    </Dialog>

                    <Dialog fullWidth={true} maxWidth="xs" open={this.state.addExperienceDialog} onClose={() => this.setState({ addExperienceDialog: false, typeOfExperience: null, yearsOfExperience: 0, isEdit: false, selectedHistoryRole: null, selectedHistoryClient: null, selectedHistoryDescipline: null })}>
                        <DialogTitle>
                            Add Experience
                        </DialogTitle>
                        <DialogContent>
                            {!this.state.isEdit ?
                                <Autocomplete
                                    style={{ marginBottom: '10px' }}
                                    value={this.state.typeOfExperience}
                                    options={[{ id: 'role_history', name: 'Role History' }, { id: 'power_history', name: 'Power History' }, { id: 'bb_history', name: 'BB History' }, { id: 'client_history', name: 'Client History' }, { id: 'descipline_history', name: 'Discipline History' }]}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && option.id === value}
                                    onChange={(e, val) => { this.setState({ typeOfExperience: val, selectedHistoryRole: null, selectedHistoryClient: null, selectedHistoryDescipline: null }) }}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Type of Experience" />}
                                /> : null}
                            {!this.state.isEdit ? (
                                <>
                                    {this.state.typeOfExperience && this.state.typeOfExperience.id === 'role_history' ?
                                        <Autocomplete
                                            style={{ marginBottom: '10px' }}
                                            value={this.state.selectedHistoryRole}
                                            options={this.state.lookupData?.job_title}
                                            getOptionLabel={(option) => option.name}
                                            isOptionEqualToValue={(option, value) => value && option.id === value}
                                            onChange={(e, val) => { this.setState({ selectedHistoryRole: val }) }}
                                            fullWidth
                                            renderInput={(params) => <TextField variant="outlined" {...params} label="Role" />}
                                        /> : this.state.typeOfExperience && this.state.typeOfExperience.id === 'client_history' ?
                                            <Autocomplete
                                                style={{ marginBottom: '10px' }}
                                                value={this.state.selectedHistoryClient}
                                                options={this.state.clientData}
                                                getOptionLabel={(option) => option.name}
                                                isOptionEqualToValue={(option, value) => value && option.id === value}
                                                onChange={(e, val) => { this.setState({ selectedHistoryClient: val }) }}
                                                fullWidth
                                                renderInput={(params) => <TextField variant="outlined" {...params} label="Client" />}
                                            /> : this.state.typeOfExperience && this.state.typeOfExperience.id === 'descipline_history' ?
                                                <Autocomplete
                                                    style={{ marginBottom: '10px' }}
                                                    value={this.state.selectedHistoryDescipline}
                                                    options={this.state.lookupData?.subsector}
                                                    getOptionLabel={(option) => option.name}
                                                    isOptionEqualToValue={(option, value) => value && option.id === value}
                                                    onChange={(e, val) => { this.setState({ selectedHistoryDescipline: val }) }}
                                                    fullWidth
                                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Discipline" />}
                                                /> : null}
                                </>
                            ) : null}
                            <TextField
                                style={{ marginBottom: '7px' }}
                                id="employee_history_year"
                                label="Year"
                                value={this.state.yearsOfExperience}
                                type="number"
                                variant="outlined"
                                onChange={e => this.setState({ yearsOfExperience: e.target.value })}
                                fullWidth
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' size='small' onClick={() => this.setState({ addExperienceDialog: false, typeOfExperience: null, yearsOfExperience: 0, isEdit: false, selectedHistoryRole: null, selectedHistoryClient: null, selectedHistoryDescipline: null })} color="secondary">
                                Cancel
                            </Button>
                            <Button variant='contained' size='small' disabled={this.state.createExperienceDisabled} onClick={() => this.state.isEdit ? this.editEmployeeHistory() : this.createEmployeeHistory()} color="primary">
                                {this.state.isEdit ? 'Edit' : 'Submit'}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog maxWidth='xs' fullWidth open={this.state.businessUnitDialog} onClose={() => this.setState({ businessUnitDialog: false, selectedBusinessUnit: {} })}>
                        <DialogTitle>
                            Business Unit
                        </DialogTitle>
                        <DialogContent>
                            <Box margin={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                <Autocomplete
                                    style={{ marginBottom: '7px' }}
                                    id="business_unit"
                                    value={this.state.selectedBusinessUnit}
                                    options={this.state.businessUnitDropdown}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => value && option.id === value}
                                    onChange={(e, val) => this.setState({ selectedBusinessUnit: val })}
                                    fullWidth
                                    renderInput={(params) => <TextField variant="outlined" {...params} label="Business Unit" />}
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' size='small' onClick={() => this.setState({ businessUnitDialog: false, selectedBusinessUnit: {} })} color="secondary">
                                Cancel
                            </Button>
                            <Button variant='contained' size='small' color="primary" onClick={() => this.linkBusinessUnit()}>
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog size='md' fullWidth open={this.state.atrDialog} onClose={() => this.setState({ atrDialog: false })}>
                        <DialogTitle>Import from ATR</DialogTitle>
                        <DialogContent>
                            <MaterialTable
                                title=""
                                columns={[
                                    { title: 'BBUK Number', field: 'bbuk_number' },
                                ]}
                                data={this.state.atrData}
                                isLoading={this.state.r12Loading}
                                options={{
                                    paging: false,
                                    search: true,
                                    filtering: true,
                                    toolbar: false,
                                }}
                                onRowClick={(event, rowData) => this.addSelectedUser(rowData)}
                            />
                        </DialogContent>
                    </Dialog>

                    <Dialog
                        open={this.state.commentDialog}
                        onClose={() => this.commentDialogClose()}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth={'md'}
                        fullWidth={true}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            <Box display='flex' flexDirection='row' alignItems='center'>
                                <IconButton size="small" onClick={() => this.commentDialogClose()}>
                                    <CloseIcon fontSize='small' color='error' />
                                </IconButton>
                                <Typography variant="h6">
                                    {this.state.selectedEmp ? this.state.selectedEmp?.first_name + ' ' + this.state.selectedEmp?.last_name + ' (Emp. No - ' + this.state.selectedEmp?.emp_no + ')' : ''}
                                </Typography>
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            {this.state.selectedEmp && <CommentSection empData={this.state.selectedEmp} updateComment={this.updateComment} />}
                        </DialogContent>
                    </Dialog>
                </div >
            }
        </>)
    }
}

export default withSnackbar(withStyles(useStyles)(Users))